import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a2ee4ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card card-drawer background-fb" }
const _hoisted_2 = {
  class: "d-flex flex-column",
  style: {"height":"100%"}
}
const _hoisted_3 = {
  id: "button-container",
  class: "d-flex flex-row flex-wrap align-items-center",
  style: {"padding":"5px 12px 0","gap":"0","height":"35px","box-sizing":"border-box","border-bottom":"1px solid lightgray"}
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fake-icon" }, [
  /*#__PURE__*/_createElementVNode("em", null, "f")
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "step-drawer-content" }
const _hoisted_10 = ["id"]
const _hoisted_11 = {
  id: "step-draft",
  class: "d-flex flex-column size step-draft-panel"
}
const _hoisted_12 = { class: "p-8-16" }
const _hoisted_13 = {
  key: 0,
  class: "actions-warning-div"
}
const _hoisted_14 = { class: "warning-text margin-left-3" }
const _hoisted_15 = { id: "name" }
const _hoisted_16 = {
  key: 1,
  class: "warning-div"
}
const _hoisted_17 = { class: "warning-text" }
const _hoisted_18 = {
  key: 2,
  id: "continueOnStepFail",
  class: "d-flex gap-2 margin-top-18 align-items-center"
}
const _hoisted_19 = { id: "connection" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1))
const _hoisted_21 = { style: {"float":"left"} }
const _hoisted_22 = ["src"]
const _hoisted_23 = ["src"]
const _hoisted_24 = {
  key: 3,
  id: "revision",
  class: "margin-top-10"
}
const _hoisted_25 = {
  key: 4,
  class: "action d-flex flex-row justify-content-between align-items-center"
}
const _hoisted_26 = {
  key: 5,
  id: "action"
}
const _hoisted_27 = { class: "d-flex flex-row justify-content-between align-items-center" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1))
const _hoisted_29 = {
  key: 0,
  id: "action-group",
  class: "margin-bottom-10"
}
const _hoisted_30 = {
  key: 1,
  class: "loader-div-40"
}
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  key: 3,
  class: "action-truncation-hint"
}
const _hoisted_33 = {
  id: "action-settings",
  class: "mt-3"
}
const _hoisted_34 = { id: "action-form-wrapper" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1))
const _hoisted_36 = { class: "margin-top-10" }
const _hoisted_37 = {
  key: 0,
  class: "customize-json-editor",
  style: {"height":"350px"}
}
const _hoisted_38 = {
  key: 1,
  class: "custom-request-body"
}
const _hoisted_39 = {
  key: 0,
  class: "color-red font-size-12 margin-bottom-10"
}
const _hoisted_40 = {
  key: 0,
  class: "p-8-16 step-details-footer"
}
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "mt-2" }
const _hoisted_43 = { class: "translations" }
const _hoisted_44 = ["id"]
const _hoisted_45 = {
  id: "step-draft",
  class: "d-flex flex-column size"
}
const _hoisted_46 = ["id"]
const _hoisted_47 = { class: "d-flex justify-content-between" }
const _hoisted_48 = { class: "d-flex align-items-center justify-content-end gap-2 add-btn-wrapper" }
const _hoisted_49 = {
  key: 1,
  class: "d-flex align-items-center full-width justify-content-center margin-top-10"
}
const _hoisted_50 = { class: "udv-field-column" }
const _hoisted_51 = { class: "udv-field-column" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "udv-action-column" }, null, -1))
const _hoisted_53 = { class: "d-flex flex-column margin-top-10 udv-field-column" }
const _hoisted_54 = ["onMouseenter"]
const _hoisted_55 = ["value", "id", "data-id"]
const _hoisted_56 = ["id", "onInput", "onClick"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "preview form-control",
  style: {"display":"none"}
}, null, -1))
const _hoisted_58 = { class: "d-flex flex-column margin-top-10 udv-field-column" }
const _hoisted_59 = ["onMouseenter"]
const _hoisted_60 = ["value", "id", "data-id"]
const _hoisted_61 = ["id", "onClick"]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "preview form-control",
  style: {"display":"none"}
}, null, -1))
const _hoisted_63 = { class: "d-flex align-items-center justify-content-center margin-top-10 udv-action-column" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = ["id"]
const _hoisted_66 = {
  id: "step-draft",
  class: "d-flex flex-column size"
}
const _hoisted_67 = ["id"]
const _hoisted_68 = { class: "d-flex justify-content-between" }
const _hoisted_69 = { class: "d-flex align-items-center justify-content-end gap-2 add-btn-wrapper" }
const _hoisted_70 = {
  key: 1,
  class: "d-flex align-items-center full-width justify-content-center margin-top-10"
}
const _hoisted_71 = { class: "udv-field-column" }
const _hoisted_72 = { class: "udv-field-column" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "udv-action-column" }, null, -1))
const _hoisted_74 = { class: "d-flex flex-column margin-top-10 udv-field-column" }
const _hoisted_75 = ["onMouseenter"]
const _hoisted_76 = ["value", "id", "data-id"]
const _hoisted_77 = ["id", "onInput", "onClick"]
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "preview form-control",
  style: {"display":"none"}
}, null, -1))
const _hoisted_79 = { class: "d-flex flex-column margin-top-10 udv-field-column" }
const _hoisted_80 = ["onMouseenter"]
const _hoisted_81 = ["value", "id", "data-id"]
const _hoisted_82 = ["id", "onClick"]
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "preview form-control",
  style: {"display":"none"}
}, null, -1))
const _hoisted_84 = { class: "d-flex align-items-center justify-content-center margin-top-10 udv-action-column" }
const _hoisted_85 = ["onClick"]

import { JsonForms } from "@jsonforms/vue";
import { createAjv } from "@jsonforms/core";
import {
  computed,
  defineAsyncComponent,
  inject,
  onBeforeMount,
  onUnmounted,
  provide,
  ref,
  shallowRef,
  markRaw,
  watch,
  watchEffect,
  onMounted,
  nextTick,
} from "vue";
import { cloneDeep, debounce, isEmpty, isEqual } from "lodash-es";
import {
  ElButton,
  ElInput,
  ElOption,
  ElOptionGroup,
  ElScrollbar,
  ElSelect,
  ElTag,
  ElTooltip,
  ElCheckbox,
  ElSwitch,
  ElDivider,
  ElTabs,
  ElTabPane,
} from "element-plus";
import { TYPE } from "vue-toastification";
import { renderers, styles } from "@/core/json-forms";
import {
  isValidJsonBody,
  tokensToText,
} from "@/flow/components/customRequestBody";
import {
  connectWebsocket,
  getFlowActiveValue,
  simulateStep,
  getRevision,
  getElasticLogs,
  isDynamicConnector,
  getAllActions,
  getConsumerActions,
} from "@/flow/services/flow.service";
import {
  getFlowLogByActivityId,
  getFlowLogZipById,
  splitByTime,
} from "@/dashboard/services/flow_log.service";
import { currentRoute } from "@/core/router";
import { showAlert } from "@/core/popup";
import i18n from "@/core/i18n/i18n";
import { getBaseUrl, getTenantId } from "@/core/api";
import { authInfo, updateSinglePreference } from "@/core/auth";
import { getPreferenceValue } from "@/core/preferences/preferences";
import { ASSETS_BASE_URL, DEFAULT_LOGO, getResolution } from "@/core/logo";
import { useStepDisplay } from "@/core/composables/useStepDisplay";
import { useActivity } from "@/flow/application/activity";
import WebsocketUrlProvider from "@/core/services/websocketUrl.provider";
import { getParameter } from "@/core/util";
import {
  createHTMLSpanElement,
  setTagDisplayText,
  getCaretPosition,
  setCaretPosition,
  saveCaretPosition,
  ensureCaretRestored,
  handleBackspaceZWSP,
  copyContainerContent,
  handlePastedHtml,
  isOurSpanHtml,
} from "@/core/json-forms/components/service";
import {
  addOutput as commonAddOutput,
  addSystemVariable as commonAddSystemVariable,
  addFunction as commonAddFunction,
} from "@/core/json-forms/components/spanInjection";
import {
  clearActiveFunctionInjectionTarget,
  getFunctionInjectionTarget,
  setActiveFunctionInjectionTarget,
} from "@/core/json-forms/components/functionInjectionTarget";
import JsonEditorVue from "json-editor-vue";
import { renderValue } from "vanilla-jsoneditor";
import { labelConvert } from "@/core/util/variable-label-convert";
import {
  normalizeOutputReference,
  PREFER_ORIG_ID_OUTPUT_REFERENCES_KEY,
} from "@/flow/utils/outputReferenceUtils";
import {
  getUdvChangeMapEntryKey,
  hasUdvValueOnlyRow,
  isUdvValueOnlyKey,
} from "@/flow/utils/preserveUdvChangeMaps";
import {
  buildActionSearchIndex,
  filterAndRankActions,
  MAX_ACTION_RESULTS,
} from "@/flow/utils/actionSearch";
import {
  getActionDetail,
  getActionDropdownRenderLimit,
  getActionGroupingThresholds,
  getActionSummaries,
} from "@/flow/services/connectorAction.service";
import {
  buildActionGroups,
  computeGroupingViability,
  deriveGroupKey,
  orderUngroupedFirst,
  summariseGroups,
} from "@/flow/utils/actionGrouping";
// Statically imported: ElSelect collects its options synchronously, and an async component emits a
// placeholder first, so the options would be missing on the first render.
import ActionOption from "@/flow/components/ActionOption.vue";
import {
  getShownConnections,
  groupConnections,
} from "@/flow/utils/connectionPickerUtils";

const USE_LEGACY_ADVANCED_EDITOR = false;
const CUSTOM_REQUEST_BODY_KEY = "x-oneteg-input-body-json";
const ALL_ACTION_GROUPS = "all";

export default /*#__PURE__*/_defineComponent({
  __name: 'EditStep',
  props: {
    stepIdx: {},
    size: {},
    connections: {},
    step: {},
    stepSimulating: { type: Boolean },
    popUpOpen: { type: Boolean },
    outputList: {},
    visible: { type: Boolean },
    isStepInRouter: { type: Boolean },
    flow: {},
    simulateDialogVisible: { type: Boolean },
    selectedBuffer: {},
    userDefinedVariables: {},
    systemVariables: {},
    expressions: {},
    idSuffix: {},
    isStepChanged: { type: Boolean },
    metaoutputList: {},
    simulationDataRefreshKey: {},
    wizardEnabled: { type: Boolean }
  },
  emits: [
  "change",
  "close",
  "simulate",
  "update",
  "updateSimulate",
  "updatePopUpOpen",
  "addStep",
  "closeDrawer",
  "setLoading",
  "change-function-visible",
  "updateOutput",
  "step-change",
  "expression-drawer",
  "udv-error",
  "updateCurrentActivityStatus",
  "simulate-for-spec",
  "save-after-spec",
  "analyze-with-wizard",
],
  setup(__props: any, { expose: __expose, emit: __emit }) {

provide("styles", styles);

const activeTab = ref("step");

const { t } = i18n.global;
const { getStepDisplayNumber } = useStepDisplay();
const preferOrigIdOutputReferences = inject(
  PREFER_ORIG_ID_OUTPUT_REFERENCES_KEY,
  true
);

const SimulateDialog = defineAsyncComponent(
  () => import("@/flow/components/SimulateDialog.vue")
);

const OutputDataDialog = defineAsyncComponent(
  () => import("@/flow/components/OutputDataDialog.vue")
);

const DataMapperDialog = defineAsyncComponent(
  () => import("@/flow/components/DataMapperDialog.vue")
);

const RequestBodyView = defineAsyncComponent(
  () => import("@/flow/components/RequestBodyView.vue")
);

const FunctionSelector = defineAsyncComponent(
  () => import("@/core/json-forms/components/FunctionSelector.vue")
);

const dialogVisible = ref(false);
const showCustomRequestBody = ref(false);

const hoveredField = ref<string>("");

const recentlyCopied = ref<string>("");

const drawerState = ref(new Map());

const selectedBodyMap = ref(new Map());

const overrideObjectList = ref([]);

const selectedVariables = ref([]);

const showExpInfo = ref(false);

const props = __props;

// Keep the previous tree editor available for a low-risk rollback while the
// Transformation Spec-style input remains the default.
const customRequestBodyData = ref<Record<string, string>>({});
const customRequestBodySchema = {
  type: "object",
  properties: {
    [CUSTOM_REQUEST_BODY_KEY]: {
      type: "string",
      title: t("Flow.CustomRequestBody"),
    },
  },
};

const customRequestBodyInvalid = ref(false);

const jsonEditorValue = ref("");

const jsonVisible = ref(false);

const isConnectionChanged = ref(false);

const selectedValue = ref();

const isActionChanged = ref(false);

const dataMapperDialogState = ref(false);

const isRequestBody = computed(
  () => selectedAction.value && selectedAction?.value.requestBodies
);

const charLimit = ref(200);

const isNameNearLimit = computed(
  () => stepName?.value?.length > charLimit.value
);

const emit = __emit;
const selectedConnectionId = ref<string>();
// Stage-1 summaries: { actionSpec: { name, description, actionType, tooltip } } — all the dropdown,
// the search index and the selection logic touch. shallowRef because the list is never mutated
// through this ref, and deep reactivity over a 2330-action list is exactly the cost this feature
// removes.
const actions = shallowRef<any[]>([]);
// The selection is the action *name*, not an index into the list: there is no full list to index
// into, and the name is what a step persists anyway.
const selectedActionName = ref<string>();
// The one action whose form is rendered. Assigned in a single step when a fetch completes and
// never cleared in between, so watch(selectedAction) always sees a real old->new transition rather
// than old->undefined->new (which would drop preserved form values).
const selectedActionDetail = shallowRef<any>();
const actionLoading = ref(false);
const actionDetailLoading = ref(false);
// Set by refreshStep(): the user cleared the step, so its saved action is no longer something to
// honour and the sole-action convenience applies again. Scoped to this panel instance, which the
// parent re-creates on every step click, so re-opening the step restores the saved-action guard.
const savedActionDiscarded = ref(false);

const actionQuery = ref("");
// One "page" of options. The rendered window grows by this much each time the user scrolls to the
// bottom of the dropdown.
const actionPageSize = ref(MAX_ACTION_RESULTS);
const renderedActionCount = ref(MAX_ACTION_RESULTS);
const actionGroupingThresholds = ref({ minPrefixRatio: 0.8, minPerGroup: 3 });

// Whether the groups are picked from their own dropdown instead of heading the action list. A
// display preference of the user's, never part of the step: two people editing the same flow must
// not save different data because they browse the action list differently.
const groupSelectorEnabled = ref(
  getPreferenceValue("groupActionsInSeparateDropdown") === true
);
// Sentinel for "no group filter". Namespaced apart from the real keys, which are always rendered
// as `tag:<key>`, so no connector tag can ever collide with it.
const selectedActionGroup = ref<string>(ALL_ACTION_GROUPS);

/** The value a group key takes in the selector. Null is the untagged bucket. */
function actionGroupValue(key: string | null): string {
  return key === null ? "ungrouped" : `tag:${key}`;
}

function actionGroupValueOf(entry: any): string {
  return actionGroupValue(
    deriveGroupKey(entry?.action?.actionSpec?.description)
  );
}

const actionSearchIndex = computed(() => buildActionSearchIndex(actions.value));

// Every action the connector offers, in source order. Grouping decisions are taken from this and
// not from the ranked list: a search narrows the actions, and neither the group selector's rows
// nor its own visibility may change under the user while they type.
const allActionEntries = computed(() =>
  filterAndRankActions(actionSearchIndex.value, "", Infinity)
);

// Ranked in full — the window is applied afterwards, so scrolling never re-ranks or re-fetches.
const rankedActions = computed(() =>
  filterAndRankActions(actionSearchIndex.value, actionQuery.value, Infinity)
);

/**
 * Whether grouping helps for this connector at all. Computed once per action list rather than per
 * render: it needs the whole list, and the answer cannot change while that list is the same.
 */
const actionGroupingViable = computed(() =>
  computeGroupingViability(
    allActionEntries.value,
    actionGroupingThresholds.value
  )
);

// Both halves are required: a connector with no usable groups offers neither the checkbox nor the
// selector, so the preference can never leave half a UI behind.
const showActionGroupSelector = computed(
  () => actionGroupingViable.value && groupSelectorEnabled.value
);

const actionGroupSummaries = computed(() =>
  summariseGroups(allActionEntries.value, t("Flow.UngroupedActions")).map(
    (group) => ({ ...group, value: actionGroupValue(group.key) })
  )
);

// Untagged actions are hoisted whenever the tag order is in play. Searching turns it off: results
// are already ordered by relevance and re-ordering them would fight that.
const actionOrderingActive = computed(
  () => actionGroupingViable.value && !actionQuery.value
);

// Inline headers, on the other hand, are also dropped in selector mode — the group is already
// named in the dropdown above, so a header would only repeat it.
const actionGroupingActive = computed(
  () => actionOrderingActive.value && !showActionGroupSelector.value
);

const actionGroupFilterActive = computed(
  () =>
    showActionGroupSelector.value &&
    selectedActionGroup.value !== ALL_ACTION_GROUPS
);

// Filtering after ranking is what makes the search search *within* the selected group; whoever
// wants the whole catalogue goes back to "All groups".
const groupScopedActions = computed(() =>
  actionGroupFilterActive.value
    ? rankedActions.value.filter(
        (entry) => actionGroupValueOf(entry) === selectedActionGroup.value
      )
    : rankedActions.value
);

const orderedActions = computed(() =>
  actionOrderingActive.value
    ? orderUngroupedFirst(groupScopedActions.value)
    : groupScopedActions.value
);

// A row drops its tag only when something above it already names the group. Under "All groups" the
// rows come from everywhere and nothing does, so the tag has to stay.
const actionRowsDropTag = actionGroupFilterActive;

/**
 * The window, plus the selected action when it falls outside it. ElSelect resolves the closed
 * select's text from a mounted option and displays the raw model value when there is none, so a
 * saved action past the render cap showed its name instead of its label. Appending it also puts the
 * current selection back within reach of a dropdown too long to render whole.
 */
const filteredActions = computed(() => {
  const shown = orderedActions.value.slice(0, renderedActionCount.value);
  if (!selectedActionName.value) {
    return shown;
  }
  const selectedIx = orderedActions.value.findIndex(
    (entry) => entry?.action?.actionSpec?.name === selectedActionName.value
  );
  if (selectedIx < renderedActionCount.value) {
    return shown;
  }
  return [...shown, orderedActions.value[selectedIx]];
});

const actionGroups = computed(() =>
  actionGroupingActive.value
    ? buildActionGroups(filteredActions.value, t("Flow.UngroupedActions"))
    : null
);

const hasMoreActions = computed(
  () => renderedActionCount.value < orderedActions.value.length
);

/** Only worth a hint line when there was ever more than one page to show. */
const showActionCountHint = computed(
  () => orderedActions.value.length > actionPageSize.value
);

function resetActionWindow() {
  renderedActionCount.value = actionPageSize.value;
}

function loadMoreActions() {
  if (!hasMoreActions.value) {
    return;
  }
  renderedActionCount.value += actionPageSize.value;
}

function onActionFilter(query: string) {
  actionQuery.value = query ?? "";
  resetActionWindow();
}

function onActionDropdownVisibleChange(visible: boolean) {
  if (visible) {
    actionQuery.value = "";
    resetActionWindow();
  }
}

/**
 * Picking another group drops the action: the two dropdowns are dependent, and leaving a selection
 * that the list below no longer offers shows a step whose action is not in its own group.
 *
 * The clearing runs through the normal selection path — watch(selectedAction) resets the form, the
 * body map and the schema, and emits — so there is only ever one place that tears an action down.
 */
function onActionGroupChange() {
  resetActionWindow();
  if (selectedActionName.value) {
    selectedActionName.value = undefined;
    onStepChange();
  }
}

function persistGroupSelectorPreference() {
  updateSinglePreference(
    "groupActionsInSeparateDropdown",
    groupSelectorEnabled.value
  );
}

/**
 * Points the selector at the group of whatever action is currently selected, so a saved step opens
 * showing where its action lives — and inside a filter that contains it.
 *
 * Deliberately not a watcher on the selection: it must not fire when the *user* picks an action,
 * which would narrow the list under them. Only a new action list, or the selector appearing, can
 * move it.
 */
watch([showActionGroupSelector, actions], () => {
  // A new connector (or revision) means a new list, and switching the selector on or off changes
  // how much of it is shown; never inherit the previous window through either.
  resetActionWindow();
  if (!showActionGroupSelector.value) {
    return;
  }
  const selected = actions.value.find(
    (action) => action?.actionSpec?.name === selectedActionName.value
  );
  selectedActionGroup.value = selected
    ? actionGroupValue(deriveGroupKey(selected.actionSpec?.description))
    : ALL_ACTION_GROUPS;
});

const actionSentinelRef = ref<HTMLElement | null>(null);
let actionSentinelObserver: IntersectionObserver | null = null;

function disconnectActionSentinel() {
  if (actionSentinelObserver) {
    actionSentinelObserver.disconnect();
  }
  actionSentinelObserver = null;
}

// The sentinel is re-created whenever the window grows, so the observer follows the new element.
// Environments without IntersectionObserver (jsdom by default) simply never auto-load; the list
// still works, it just stops at the first page.
watch(actionSentinelRef, (sentinel) => {
  disconnectActionSentinel();
  if (!sentinel || typeof IntersectionObserver === "undefined") {
    return;
  }
  actionSentinelObserver = new IntersectionObserver((entries) => {
    if (entries.some((entry) => entry.isIntersecting)) {
      loadMoreActions();
    }
  });
  actionSentinelObserver.observe(sentinel);
});

onUnmounted(disconnectActionSentinel);
const formData = ref({});
const errors = ref([]);
const schema = ref();
const configurationSchemas = ref([]);
const ajv = createAjv({ useDefaults: true });
// Register the selection-set-tree marker so AJV doesn't reject it as an unknown format (it is a
// renderer hint, not a validated string format). Without this, an object-returning GraphQL action
// whose selectionSet node carries this format crashes the whole action form.
ajv.addFormat("graphql-selection-set", () => true);

const stepName = ref("");
const continueOnFail = ref(false);
const continueOnFailDisable = ref(false);
const translationDialog = ref(false);
const translations = ref([]);

const simulating = ref(false);
const processLogs = ref();
const outputData = ref();
const metaoutputData = ref();
const metaoutputDataList = ref([]);
const nextOutputData = ref();
const outputDataList = ref([]);
const defaultOutput = ref([]);
const alternativeOutput = ref([]);

const actionChanged = ref(0);

const contentPath = ref("");

let resultList = [];

let client;

const restUrl = ref("");

const modalVisibleKey = ref("");

const flowId = computed(() => currentRoute.value.params.id as string);

const flowVersion = computed(() => currentRoute.value.params.version as string);

const activityId = ref("");

const revisions = ref([]);

const selectedRevision = ref("");

watch(selectedRevision, (newRevision) => {
  stepData.value.revision = newRevision;
});

function copyDefinitionContent(index: number, side: string) {
  const divId = `${side}-${index}-div-${props.idSuffix}`;
  copyContainerContent(divId)
    .then(() => {
      recentlyCopied.value = divId;
      setTimeout(() => {
        if (recentlyCopied.value === divId) {
          recentlyCopied.value = "";
        }
      }, 2000);
    })
    .catch((err) => {
      console.error("Copy failed:", err);
    });
}

async function fetchRevisions() {
  const connector = selectedConnection?.value.connector;
  const connectionId = isDynamicConnector(connector)
    ? selectedConnection?.value.id
    : undefined;
  const revisionData = await getRevision(
    connector?.connectorSpecId,
    connectionId
  );
  if (revisionData) {
    revisions.value = revisionData;
    if (
      props?.step?.revision !== undefined &&
      props?.step?.revision !== null &&
      props.step?.connection?.id === selectedConnection?.value?.id
    ) {
      selectedRevision.value = props.step.revision;
    } else if (props.step?.id?.includes("new")) {
      selectedRevision.value = revisions.value[revisions.value.length - 1];
    } else {
      // eslint-disable-next-line
      selectedRevision.value = revisions.value[revisions.value.length - 1];
    }
  } else {
    revisions.value = [];
  }
}

const elDrawerOpen = computed(() => {
  let boolean = false;
  drawerState.value.forEach((value) => {
    if (value) {
      boolean = true;
    }
  });
  return boolean || translationDialog.value;
});

watch(
  () => elDrawerOpen.value,
  () => {
    jsonVisible.value = false;
    emit("change-function-visible", elDrawerOpen.value);
  }
);

watch(
  () => selectedConnectionId.value,
  async () => {
    await nextTick();
    updatePadding();
  }
);
const dataMappingObject = ref({
  dataMapping: undefined,
  targetStepId: undefined,
  srcConnectorSpecId: undefined,
  targetConnectorSpecId: undefined,
});

const nextStepData = ref({
  targetConnectorSpecId: undefined,
  targetStepId: undefined,
});

const savedMap = ref([]);

const simulateDialogVisible = ref(false);
const outputMap = new Map();
const selectedBuffer = ref([]);
const outputBuffer = ref([]);
const lastLogForStep = ref(null);

const innerPopUp = ref(false);
const userDefVarDialog = ref(false);
const isKeySelected = ref(false);
const isValueSelected = ref(false);
const count = ref(0);
const previousId = ref(null);
const openPopUp = computed(
  () =>
    simulateDialogVisible.value ||
    translationDialog.value ||
    dialogVisible.value ||
    dataMapperDialogState.value ||
    innerPopUp.value
);

const previousStepData = ref();
watch(
  () => openPopUp.value,
  () => {
    emit("updatePopUpOpen", openPopUp.value);
  }
);

function updatePadding() {
  const element = document.getElementById("flow-connection-select");
  if (element && selectedConnectionId.value) {
    element.style.paddingLeft = "43px";
    element.style.borderColor =
      selectedConnection.value && !selectedConnection.value.active
        ? "rgba(255,193,7,255)"
        : "";
  } else {
    element.style.paddingLeft = "30px";
  }
}

function popUpOpened(isOpen) {
  innerPopUp.value = isOpen;
}

function toggleShowCustomRequestBody() {
  showCustomRequestBody.value = !showCustomRequestBody.value;
}

const webhookUrl = computed(() => {
  const tenantId = getTenantId();
  if (flowId.value && tenantId && restUrl.value) {
    return `${restUrl.value}/webhook/${tenantId}/${authInfo.value.organizationId}/flow/${flowId.value}`;
  }
  return "";
});

const dropdownSize = computed(() =>
  props.size <= 520 ? "520px" : `${props.size}px`
);

const renameTooltipFieldsInSchema = (s) => {
  Object.values(s.properties).forEach(renameTooltipFieldsInProperty);
  return s;
};

const renameTooltipFieldsInProperty = (property) => {
  if ("tooltip" in property) {
    property.description = property.tooltip;
    delete property.tooltip;
    if ("items" in property) {
      renameTooltipFieldsInProperty(property.items);
    }
  }
};

function isWebhook() {
  if (selectedConnection.value) {
    return (
      selectedConnection.value.connector.connectorSpecId.includes("webhook") &&
      flowId.value &&
      typeof stepData.value.id === "string" &&
      !stepData.value.id.includes("new")
    );
  }
  return false;
}
function handleClickEvent(isDrawerOpen, controlId) {
  drawerState.value.set(controlId, isDrawerOpen);
}
function expressionDrawer(drawerStatus) {
  emit("expression-drawer", drawerStatus);
}
function copyUrlToClipboard() {
  navigator.clipboard.writeText(webhookUrl.value);
  showAlert(TYPE.SUCCESS, "Url copied");
}

/* Check Log */
const checkFailedContentData = ref({
  numberOfTime: 0,
  logLength: 0,
  hasFailed: false,
  checkOfTime: 0,
});
function onStepChange() {
  stepChanges.value = true;
  emit("step-change", stepChanges.value);
}

function onStepNameInput() {
  onStepChange();
  debouncedEmitChange();
}
const debouncedEmitChange = debounce(() => {
  emitStepData();
}, 300);
const simulateButtonVisibility = ref(false);
const lastSimulateReason = ref<string | null>(null);

async function simulate(
  bypassConditions,
  opts: { silent?: boolean; reason?: string } = {}
) {
  const silent = !!opts?.silent;
  lastSimulateReason.value = opts?.reason ?? null;
  simulateButtonVisibility.value = true;
  const flowActive = await getFlowActiveValue(flowId.value, flowVersion.value);
  if (flowActive && !stepChanges.value) {
    if (client) {
      client.disconnect();
      client = undefined;
    }
    try {
      selectedBuffer.value = [];
      outputBuffer.value = [];
      outputMap.clear();
      const stepId = props.step?.id;

      if (
        typeof stepData.value.id === "string" &&
        !stepData.value.id.includes("new") &&
        flowId.value
      ) {
        simulating.value = true;
        activityId.value = await simulateStep(
          stepId,
          flowId.value,
          flowVersion.value,
          bypassConditions
        );
        const { checkIsRunActivityFromSocket } = useActivity();
        connectWebsocket()
          .then((stompClient) => {
            stompClient.debug = (f) => f;
            client = stompClient;
            stompClient.connect({}, async () => {
              if (!silent) simulateDialogVisible.value = true;
              outputMap.set(flowId, outputBuffer.value);
              selectedBuffer.value = outputBuffer.value;
              // Since the initialization message added for
              // simulation in the gateway could not be displayed in the process logs,
              // the message is added to the buffer in the UI within the scope of OT-2382 ticket.
              outputBuffer.value.push(
                `${t("Flow.SimulationInitialLog")} ${stepData.value.flow.name}`
              );
              stompClient.subscribe(
                WebsocketUrlProvider.ActivityProgress(activityId.value),
                (val) => {
                  outputBuffer.value.push(val.body);
                  checkFailedContentData.value.hasFailed =
                    val.body.includes("Failed");
                }
              );
              /* Check Data */
              if (simulating.value) {
                const checkOfTime = parseInt(
                  await getParameter("FLOW_PROCESS_LOG_CHECKS_INTERVAL"),
                  0
                );
                const numberOfTime = parseInt(
                  await getParameter("FLOW_LOG_CHECKS_TOTAL"),
                  0
                );
                const timeout = parseInt(
                  await getParameter("FLOW_PROCESS_LOG_CHECKS_TIMEOUT"),
                  0
                );
                const customInterval = setInterval(() => {
                  checkFailedContentData.value = {
                    ...checkFailedContentData.value,
                    checkOfTime:
                      outputBuffer.value.length ===
                      checkFailedContentData.value.logLength
                        ? checkFailedContentData.value.checkOfTime + 1
                        : checkFailedContentData.value.checkOfTime,
                    logLength: outputBuffer.value.length,
                    numberOfTime: checkFailedContentData.value.numberOfTime + 1,
                  };
                  if (
                    checkFailedContentData.value.checkOfTime > checkOfTime ||
                    checkFailedContentData.value.numberOfTime > numberOfTime
                  ) {
                    simulating.value = false;
                    clearInterval(customInterval);
                    checkFailedContentData.value = {
                      numberOfTime: 0,
                      logLength: 0,
                      hasFailed: false,
                      checkOfTime: 0,
                    };
                  }
                }, timeout);
              }
              isActionChanged.value = false;
              simulating.value = await checkIsRunActivityFromSocket(
                stompClient,
                activityId.value,
                emitUpdateOutput,
                emitUpdateCurrentActivityStatus
              );
            });
          })
          .catch(() => {
            console.log("catch");
          });
      }
    } catch (e) {
      simulating.value = false;
      const msg =
        lastSimulateReason.value === "validate-after-spec"
          ? t("Flow.JoltValidationFailed")
          : e.message ?? t("Common.UnknownError");
      showAlert(TYPE.ERROR, msg);
    }
  } else if (!flowActive) {
    showAlert(TYPE.ERROR, t("Flow.InactiveStep"));
  } else if (stepChanges.value) {
    showAlert(TYPE.WARNING, t("Flow.UnsavedChanges"));
  }
  simulateButtonVisibility.value = false;
  processLogs.value = outputBuffer.value;
}

function emitUpdateOutput() {
  emit("updateOutput");
}

function emitUpdateCurrentActivityStatus(activityStatus) {
  emit("updateCurrentActivityStatus", activityStatus);
}
function resetConnectionAndActionChanges() {
  isConnectionChanged.value = false;
  isActionChanged.value = false;
}
async function downloadLogsAsText(flowVal) {
  if (!processLogs.value) {
    showAlert(TYPE.WARNING, t("Flow.ProcessLogDownloadError"));
    return;
  }
  const response = await getFlowLogZipById(activityId.value);
  const blob = new Blob([response], { type: "application/zip" });
  const link = document.createElement("a");
  link.setAttribute("download", `${flowVal.name}-flow-logs.zip`);
  link.href = URL.createObjectURL(blob);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
}

function setContentPath(data) {
  if (outputData.value.includes("invalid output")) {
    return;
  }

  if (data) {
    contentPath.value = data.path;
  }
  emitStepData();
}

function clearContentPath() {
  contentPath.value = "";
  emitStepData();
}

watch(
  () => actionLoading.value,
  () => {
    emit("setLoading", actionLoading.value);
  }
);

function disableOutputButton() {
  return simulateDialogVisible.value
    ? isEmpty(outputData.value) || simulateDialogVisible.value
    : simulateDialogVisible.value;
}

function onFormChange(event) {
  formData.value = schema.value ? event.data : {};
  errors.value = event.errors;
  previousStepData.value = stepData.value;
  debouncedEmitChange();
}

const shownConnections = computed(() =>
  getShownConnections(props.connections, {
    stepIdx: props.stepIdx,
    isStepInRouter: props.isStepInRouter,
    stepIx: stepData.value?.ix,
    webhookConnectorSpecId: t("Connector.WebhookConnectorSpecId"),
  })
);

const groupedConnections = computed(() =>
  groupConnections(shownConnections.value)
);

const selectedConnection = ref();

watch(
  () => selectedConnectionId.value,
  () => {
    if (selectedConnectionId.value) {
      if (selectedConnection.value) {
        if (selectedConnection.value.id !== selectedConnectionId.value) {
          isConnectionChanged.value = true;
        }
      }
      selectedConnection.value = shownConnections.value.find(
        (connection) => connection.id === selectedConnectionId.value
      );
    } else {
      selectedConnection.value = undefined;
    }
  }
);

watchEffect(() => {
  if (actions?.value?.length !== 1 || selectedActionName.value) {
    return;
  }
  const savedActionName =
    props.step.actions && !savedActionDiscarded.value
      ? Object.keys(props.step.actions)[0]
      : undefined;
  // Auto-selecting the sole action is a convenience for a step with nothing to restore. When the
  // step has a saved action that this list does not offer, the selection must stay empty: picking
  // the only other action would silently swap the step's action and mark it dirty.
  if (
    savedActionName &&
    !actions.value.some(
      (action) => action?.actionSpec?.name === savedActionName
    )
  ) {
    return;
  }
  selectedActionName.value = actions.value[0]?.actionSpec?.name;
});
watch(
  () => props.isStepChanged,
  (newVal) => {
    stepChanges.value = newVal;
  }
);
const selectedAction = computed(() =>
  selectedActionName.value ? selectedActionDetail.value : undefined
);

/**
 * True while a selected action's form definition is still being fetched — the window in which
 * `selectedAction` disagrees with `selectedActionName`. Nothing may be emitted to the parent
 * during it: `stepData` would otherwise report the step as having no action and wipe the saved
 * one.
 */
const actionSelectionPending = computed(
  () =>
    !!selectedActionName.value &&
    selectedActionDetail.value?.actionSpec?.name !== selectedActionName.value
);

/** Every `emit("change", stepData.value)` goes through here so the guard cannot be forgotten. */
function emitStepData() {
  if (actionSelectionPending.value) {
    return;
  }
  emit("change", stepData.value);
}
const stepData = computed(() => {
  // A selection whose definition has not arrived yet is not "no action". Reporting the blanked
  // shape below would clear the step's saved action and connection mid-fetch, so hold the step
  // as-is and let only the locally-edited fields through.
  if (actionSelectionPending.value) {
    return {
      ...props.step,
      active: true,
      name: stepName.value,
      continueOnFail: continueOnFail.value,
    };
  }
  if (!selectedConnection.value || !selectedAction.value) {
    return {
      ...props.step,
      id: props.step?.id,
      ix: props.step?.ix,
      iy: props.step?.iy,
      position: props.step?.position,
      active: true,
      name: stepName.value,
      continueOnFail: continueOnFail.value,
      output: undefined,
      metaoutput: undefined,
      connection: undefined,
      actions: undefined,
      flow: undefined,
      translations: [],
      dataMapping: undefined,
      contentPath: undefined,
      filter: props.step?.filter,
      delay: props.step?.delay,
      revision: props.step?.revision,
      udvChangeMapBefore: props.step?.udvChangeMapBefore,
      udvChangeMapAfter: props.step?.udvChangeMapAfter,
    };
  }

  const actionDefinitions = convertToDefinitions(formData.value);
  delete actionDefinitions[CUSTOM_REQUEST_BODY_KEY];
  const customRequestBodyValue =
    customRequestBodyData.value[CUSTOM_REQUEST_BODY_KEY];

  if (USE_LEGACY_ADVANCED_EDITOR && jsonEditorValue.value) {
    actionDefinitions[CUSTOM_REQUEST_BODY_KEY] = {
      name: CUSTOM_REQUEST_BODY_KEY,
      value: JSON.stringify(parseObject(JSON.stringify(jsonEditorValue.value))),
      translations: [],
      exchangeField: null,
    };
  } else if (customRequestBodyValue && customRequestBodyValue !== "[]") {
    actionDefinitions[CUSTOM_REQUEST_BODY_KEY] = {
      name: CUSTOM_REQUEST_BODY_KEY,
      value: customRequestBodyValue,
      translations: [],
      exchangeField: null,
    };
  }

  const bodyMap =
    selectedBodyMap.value.size !== 0
      ? convertMapToBody(selectedBodyMap.value)
      : undefined;

  const outputToBeSet = ref([]);
  const metaoutputToBeSet = ref([]);
  outputToBeSet.value = props.step?.output;
  if (isConnectionChanged.value || isActionChanged.value) {
    outputToBeSet.value = undefined;
  }
  metaoutputToBeSet.value =
    props.step.metaoutput === undefined ? undefined : props.step.metaoutput;

  return {
    ...props.step,
    id: props.step?.id,
    ix: props.step?.ix,
    iy: props.step?.iy,
    position: props.step?.position,
    active: true,
    name: stepName.value,
    continueOnFail: continueOnFail.value,
    output: outputToBeSet.value,
    metaoutput: metaoutputToBeSet.value,
    revision: selectedRevision.value,
    filter: props.step?.filter,
    // Connection-optional connectors are used without a Connection: emit the connectorSpecId
    // directly on the step and no connection. Otherwise emit the connection as before.
    ...(selectedConnection.value.connectionOptional
      ? {
          connection: undefined,
          connectorSpecId: selectedConnection.value.connector.connectorSpecId,
        }
      : {
          connection: {
            id: selectedConnectionId.value,
            active: true,
            connector: {
              connectorSpecId:
                selectedConnection.value.connector.connectorSpecId,
            },
          },
          // Clear any top-level connectorSpecId left over from a prior connection-optional
          // selection (via the ...props.step spread) so the step never carries both at once.
          connectorSpecId: undefined,
        }),
    flow: props.step?.flow,
    actions: {
      [selectedAction.value.actionSpec.name]: {
        name: selectedAction.value.actionSpec.name,
        description: selectedAction.value.actionSpec.description,
        actionType: selectedAction.value.actionSpec.actionType,
        actionDefinitions,
        bodyActions: bodyMap || undefined,
      },
    },
    translations: cloneDeep(translations.value),
    dataMapping: dataMappingObject.value.dataMapping
      ? dataMappingObject.value
      : undefined,
    contentPath: contentPath.value,
    delay: props.step?.delay,
  };
});

function validateCustomRequestBody(rawValue) {
  customRequestBodyInvalid.value = !isValidJsonBody(tokensToText(rawValue));
}

const debouncedValidateCustomRequestBody = debounce(
  validateCustomRequestBody,
  600
);

function onCustomRequestBodyChange(event) {
  if (USE_LEGACY_ADVANCED_EDITOR) {
    return;
  }

  const nextData = event?.data ?? {};
  if (isEqual(customRequestBodyData.value, nextData)) {
    return;
  }

  customRequestBodyData.value = nextData;
  debouncedValidateCustomRequestBody(nextData[CUSTOM_REQUEST_BODY_KEY]);
  if (stepData.value.actions) {
    stepChanges.value = true;
    nextTick(() => {
      updateCurrentSavedData();
      stepChanges.value = false;
    });
  }
}

function jsonEditorOnClick() {
  jsonVisible.value = true;
  emit("change-function-visible", true);
}
function onSelect(prop) {
  if (prop.type === "value") {
    jsonEditorOnClick();
    selectedValue.value = prop.path;
  }
}
function onJsonEditorChange(newValue) {
  jsonEditorValue.value = newValue.target.innerText;
}
function includesAnyValue(str) {
  const values = Object.keys(types.value);
  return values.find((value) => str.includes(value));
}
function extractKey(text) {
  const prefixPattern = /^#[^#]+#/;
  const suffixPattern = /#[^#]+$/;

  const cleanedText = text.replace(prefixPattern, "");
  const result = cleanedText.replace(suffixPattern, "");

  return result;
}
function updatePropValue(type, value) {
  if (type === "OT-UDV") {
    return `.${value.replaceAll("/#", "/").replaceAll("@#", "/")}`;
  }
  if (type === "OT-SYS") {
    const tempVal = value.replaceAll("/#", "");
    return labelConvert(tempVal);
  }
  if (type === "OT-OUT") {
    const arr = value.split("/#");
    const index =
      arr.length >= 2 ? `${parseInt(arr[0].replace("/", ""), 10) + 1}` : "";
    return `${index}./${arr[1]}`;
  }
  if (type === "OT-FNC") {
    return value.replaceAll("/#", "");
  }
  return value;
}
function onRenderValue(prop) {
  const isVariable =
    typeof prop.value === "string" ? includesAnyValue(prop.value) : undefined;
  prop.value = isVariable ? extractKey(prop.value) : prop.value;
  prop.value = updatePropValue(isVariable, prop.value);
  return renderValue(prop);
}

function updateValueAtPath(obj, path, newValue) {
  let current = obj;
  for (let i = 0; i < path.length - 1; i++) {
    if (current[path[i]] === undefined) {
      current[path[i]] = {};
    }
    current = current[path[i]];
  }
  current[path[path.length - 1]] = newValue;
}

function addUserVariableToJsonEditor(data) {
  updateValueAtPath(
    jsonEditorValue.value,
    selectedValue.value,
    `#OT-UDV#${data.name}#OT-UDV`
  );
}
function addOutputToJsonEditor(data) {
  updateValueAtPath(
    jsonEditorValue.value,
    selectedValue.value,
    `#OT-OUT#${data.name}#OT-OUT`
  );
}
function addFunctionToJsonEditor(data) {
  updateValueAtPath(
    jsonEditorValue.value,
    selectedValue.value,
    `#OT-FNC#/#${data.name}#OT-FNC`
  );
}
function addSystemVariableToJsonEditor(data) {
  updateValueAtPath(
    jsonEditorValue.value,
    selectedValue.value,
    `#OT-SYS#/#${data.name}#OT-SYS`
  );
}

function convertToDefinitions(data) {
  const definitions = {};
  if (data) {
    Object.entries(data).forEach(([key, val]: any[]) => {
      if (val === "[]") {
        return;
      }
      if (typeof val === "string" && val.startsWith("[{")) {
        definitions[key] = {
          name: key,
          value: val,
          translations: JSON.parse(val),
          exchangeField: null,
        };
      } else if (typeof val === "string" && val.startsWith("/#")) {
        definitions[key] = {
          name: key,
          value: val,
          translations: null,
          exchangeField: {
            stepId: val.split("/#")[1],
            path: `/#${val.split("/#")[2]}`,
          },
        };
      } else {
        definitions[key] = {
          name: key,
          value: val,
          translations: null,
          exchangeField: null,
        };
      }
    });
  }
  return definitions;
}
onMounted(async () => {
  isHydratingUdv.value = true;
  addClickEvent();
  udvChangeMapBefore.value.forEach(async (element, index) => {
    await addToDiv(
      JSON.stringify(element.itemKey),
      `first-definition-${index}`,
      index
    );
    await addToDiv(element.itemValue, `second-definition-${index}`, index);
  });
  udvChangeMapAfter.value.forEach(async (element, index) => {
    await addToDiv(
      JSON.stringify(element.itemKey),
      `first-after-definition-${index}`,
      index
    );
    await addToDiv(
      element.itemValue,
      `second-after-definition-${index}`,
      index
    );
  });
  loadLastLogForStep();
  await nextTick();
  isHydratingUdv.value = false;
  updatePadding();
});
function userDefinedVariablesDialog() {
  userDefVarDialog.value = true;
  activeTab.value = "udv";
}
const computedId = computed(() => {
  if (focusId.value) {
    return `${focusId.value}-div-${props.idSuffix}`;
  }
  return "";
});
const focusInputId = ref(-1);
const focusId = ref("");

const editStepUdvInjectionTarget = {
  isAvailable: () =>
    Boolean(computedId.value && document.getElementById(computedId.value)),
  closeSelector: () => {
    isKeySelected.value = false;
    isValueSelected.value = false;
  },
  addOutput: (params, first, isNotFirstRender = true) =>
    addOutput(params, first, isNotFirstRender),
  addUserVariable: (data, first) =>
    addUserVariable(data, first, focusId.value.includes("first")),
  addSystemVariable: (data, first) => addSystemVariable(data, first),
  addFunction: (params, first) => addFunction(params, first),
};

function getEditStepUdvInjectionTarget(first, isNotFirstRender = true) {
  return getFunctionInjectionTarget(
    editStepUdvInjectionTarget,
    first,
    isNotFirstRender
  );
}

/* eslint-disable no-confusing-arrow */
const currentOutputList = computed(() =>
  focusId.value.includes("after")
    ? alternativeOutput.value
    : defaultOutput.value
);

const udvChangeMapBefore = ref([]);
const udvChangeMapAfter = ref([]);
const isHydratingUdv = ref(false);

function setFocusInput(index, id) {
  setActiveFunctionInjectionTarget(editStepUdvInjectionTarget);
  if (id.includes("first")) {
    isKeySelected.value = true;
    isValueSelected.value = false;
  } else {
    isValueSelected.value = true;
    isKeySelected.value = false;
  }
  if (id.includes("after")) {
    outputDataList.value = alternativeOutput.value;
  } else {
    outputDataList.value = defaultOutput.value;
  }
  focusId.value = `${id}-${index}`;
  focusInputId.value = index;
  emit("change-function-visible", true);
}
function pasteEvent(e) {
  e.stopPropagation();
  e.preventDefault();
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line no-nested-ternary
  const clipboardData = e.clipboardData || window.clipboardData;
  const pastedData = clipboardData.getData("Text");
  const html = clipboardData.getData("text/html");
  const container = document.getElementById(computedId.value);
  const range = document.getSelection().getRangeAt(0);

  if (isOurSpanHtml(html) && container) {
    handlePastedHtml(
      html,
      container,
      range,
      currentOutputList.value,
      undefined,
      {
        preferOrigId: preferOrigIdOutputReferences,
      }
    );
    setTimeout(() => {
      const isFirstInput = computedId.value.includes("first");
      const flag = determineFlagCondition();
      organizeNodes(isFirstInput, flag);
    }, 100);
    return;
  }
  range.deleteContents();
  const textNode = document.createTextNode(pastedData);
  range.insertNode(textNode);
  range.selectNodeContents(textNode);
  range.collapse(false);
  const selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);
}

function addOutput(params, first, isNotFirstRender = true) {
  const target = getEditStepUdvInjectionTarget(first, isNotFirstRender);
  if (target !== editStepUdvInjectionTarget) {
    if (target.addOutput) {
      target.addOutput(params, first, isNotFirstRender);
    }
    return;
  }

  if (params.stepIndex > -1) {
    const span: HTMLSpanElement = commonAddOutput(
      params,
      currentOutputList.value,
      count.value,
      isNotFirstRender
    );
    count.value++;
    addItemToInput(span, first, false);
  }
}
function addSystemVariable(data, first) {
  const target = getEditStepUdvInjectionTarget(first);
  if (target !== editStepUdvInjectionTarget) {
    if (target.addSystemVariable) {
      target.addSystemVariable(data, first);
    }
    return;
  }

  const span = commonAddSystemVariable(
    { name: data.name, path: data.name, stepIndex: 0 },
    props.systemVariables,
    count.value
  );
  count.value++;
  addItemToInput(span, first, false);
}
function isValueValid(value) {
  try {
    JSON.parse(value);
    return true;
  } catch (e) {
    return false;
  }
}

function onUdvKeyChange(index, flag, event) {
  if (
    event.inputType === "deleteContentBackward" ||
    event.inputType === "deleteContentForward"
  ) {
    if (flag === "before") {
      udvChangeMapBefore.value[index].itemKey = "";
    } else if (flag === "after") {
      udvChangeMapAfter.value[index].itemKey = "";
    }
  }
}
function parseUdvChangeMap(flag) {
  const formattedObj = {};
  const mapToUse =
    flag === "before" ? udvChangeMapBefore.value : udvChangeMapAfter.value;

  mapToUse.forEach((item) => {
    const value = processItemValue(item.itemValue);
    const key = getUdvChangeMapEntryKey(item);
    if (key === undefined) {
      return;
    }
    formattedObj[key] = value;
  });

  return formattedObj;
}

function getFormattedUdvChangeMap(flag) {
  const udvData = Object.entries(parseUdvChangeMap(flag))
    .filter(([key, value]) => !(key === "" && value === ""))
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});

  return udvData;
}

function emitUdvChange() {
  emit("change", {
    ...props.step,
    udvChangeMapBefore: getFormattedUdvChangeMap("before"),
    udvChangeMapAfter: getFormattedUdvChangeMap("after"),
  });
}

function createUdvErrorPayload(flag: boolean) {
  return {
    flag,
    index: stepData.value.index,
    ix: stepData.value.ix,
    stepNumber: stepData.value.stepNumber,
    id: stepData.value.id,
    origId: stepData.value.origId,
    uniqueId: stepData.value.uniqueId,
  };
}

function emitUdvValidationState() {
  const hasInvalidRow =
    hasUdvValueOnlyRow(udvChangeMapBefore.value) ||
    hasUdvValueOnlyRow(udvChangeMapAfter.value);
  emit("udv-error", createUdvErrorPayload(!hasInvalidRow));
}

function processItemValue(itemValue) {
  const valid = isValueValid(itemValue);

  try {
    const processedValue = itemValue.map((element) => {
      if (element.type === "user-defined-variable") {
        element.name = element.name.startsWith("/userDefinedVariables")
          ? element.name
          : `/userDefinedVariables${element.name}`;
      }
      return element;
    });

    return valid ? processedValue : JSON.stringify(processedValue);
  } catch (error) {
    return itemValue;
  }
}

watch(
  () => udvChangeMapBefore.value,
  () => {
    const udvData = getFormattedUdvChangeMap("before");

    stepData.value.udvChangeMapBefore = udvData;

    emitUdvValidationState();
    if (!isHydratingUdv.value) {
      emitUdvChange();
    }
  },
  { deep: true }
);

watch(
  () => udvChangeMapAfter.value,
  () => {
    const udvData = getFormattedUdvChangeMap("after");

    stepData.value.udvChangeMapAfter = udvData;

    emitUdvValidationState();
    if (!isHydratingUdv.value) {
      emitUdvChange();
    }
  },
  { deep: true }
);

function parseObject(obj) {
  const parsedObjects = [];
  const matches = extractMatches(obj);
  if (matches !== null) {
    const result = buildResult(obj, matches);
    parsedObjects.push(...result);
  } else {
    parsedObjects.push({ name: obj, type: "input" });
  }

  return parsedObjects;
}

function extractMatches(name) {
  const regex = /#OT-[A-Z]+#\/.*?#[A-Z]+-[A-Z]+/g;
  return name.match(regex);
}

function buildResult(name, matches) {
  const result = [];
  let lastIndex = 0;

  matches.forEach((match) => {
    const matchIndex = name.indexOf(match, lastIndex);
    result.push(name.slice(lastIndex, matchIndex));
    result.push(match);
    lastIndex = matchIndex + match.length;
  });

  result.push(name.slice(lastIndex));
  return parseResult(result);
}
const types = ref({
  "OT-UDV": "user-defined-variable",
  "OT-OUT": "output",
  "OT-FNC": "function",
  "OT-SYS": "system-variable",
});
function formatJsonName(name, type) {
  if (type === "OT-UDV") {
    return `/userDefinedVariables${name}`;
  }
  if (type === "OT-SYS" || type === "OT-FNC") {
    return name.substring(2);
  }
  return name;
}
function cleanString(str) {
  const cleanedStr = str
    .replaceAll(/OT-OUT|OT-UDV|OT-FNC|OT-SYS/g, "")
    .replaceAll(/OT-OUT|OT-UDV|OT-FNC|OT-SYS/g, "");
  return cleanedStr.slice(2, -1);
}
function parseResult(result) {
  const parsedResult = [];
  result.forEach((res) => {
    const type = Object.keys(types.value).find((sub) => res.includes(sub));
    const name = type !== undefined ? cleanString(res) : res;
    parsedResult.push({
      name: formatJsonName(name, type),
      type: types.value[type] || "input",
      function: "",
    });
  });

  return parsedResult;
}
watch(
  () => jsonEditorValue.value,
  () => {
    if (!USE_LEGACY_ADVANCED_EDITOR) {
      return;
    }
    if (stepData.value.actions) {
      stepChanges.value = true;
      const parsedObjects = parseObject(JSON.stringify(jsonEditorValue.value));
      const keys = Object.keys(stepData.value.actions);
      const [key] = keys;
      stepData.value.actions[key].actionDefinitions[CUSTOM_REQUEST_BODY_KEY] = {
        exchangeField: null,
        name: CUSTOM_REQUEST_BODY_KEY,
        translations: [],
        value: JSON.stringify(parsedObjects),
      };
      nextTick(() => {
        updateCurrentSavedData();
        stepChanges.value = false;
      });
    }
  },
  { deep: true }
);

function addFunction(params, first) {
  const target = getEditStepUdvInjectionTarget(first);
  if (target !== editStepUdvInjectionTarget) {
    if (target.addFunction) {
      target.addFunction(params, first);
    }
    return;
  }

  const spans = commonAddFunction(params, count.value);
  spans.forEach((span) => {
    addItemToInput(span, first, false);
  });
  count.value += spans.length;
  if (params.hasChild) {
    const mainSpan = spans[0];
    const zwsp = mainSpan.nextSibling;
    if (zwsp && zwsp.nodeType === Node.TEXT_NODE) {
      setCaretPosition(zwsp, computedId.value, 1);
    }
  }
}

watch(
  () => computedId.value,
  (newValue) => {
    if (previousId.value) {
      const oldEl = document.getElementById(previousId.value);
      if (oldEl) {
        oldEl.removeEventListener("paste", pasteEvent);
      }
    }

    const newEl = document.getElementById(newValue);
    if (newEl) {
      newEl.addEventListener("paste", pasteEvent);
    }
    previousId.value = newValue;
  }
);
function addUserVariable(data, first, isFirstInput) {
  const target = getEditStepUdvInjectionTarget(first);
  if (target !== editStepUdvInjectionTarget) {
    if (target.addUserVariable) {
      target.addUserVariable(data, first);
    }
    return;
  }

  const targetMap = focusId.value.includes("after")
    ? udvChangeMapAfter.value
    : udvChangeMapBefore.value;
  if (
    !first &&
    computedId.value.includes("first") &&
    targetMap[focusInputId.value]?.itemKey !== ""
  ) {
    return;
  }
  const innerText = `.${data.path.replaceAll("/#", "/").replaceAll("@#", "/")}`;
  const span: HTMLSpanElement = createHTMLSpanElement(
    {
      name: data.name,
      type: "user-defined-variable",
      tooltip: data.tooltip,
    },
    false,
    count.value,
    innerText
  );
  count.value++;
  setTagDisplayText(span, innerText);
  addItemToInput(span, first, isFirstInput);
}
function split(text, index) {
  return [text.slice(0, index), text.slice(index)];
}
function addClickEvent() {
  try {
    const conditionElement = document.getElementById(
      `definitons-${props.idSuffix}`
    );
    if (conditionElement) {
      conditionElement.addEventListener("click", (event: any) => {
        const isContainsPopper = document
          .getElementById(`definitons-${props.idSuffix}-popper`)
          .contains(event.target);
        const isContainsDiv = focusId.value
          ? document
              .getElementById(`${focusId.value}-div-${props.idSuffix}`)
              .contains(event.target)
          : false;
        isKeySelected.value = isContainsDiv || isContainsPopper;
      });
    }
  } catch (e) {
    isKeySelected.value = false;
  } finally {
    isKeySelected.value = false;
  }
}
async function addToDiv(data, id, index) {
  focusInputId.value = index;
  focusId.value = id;
  try {
    const element = JSON.parse(data);
    if (id.includes("first") && element !== "") {
      addUserVariable(
        {
          name: `/#${element}`,
          path: `/#${element}`,
        },
        true,
        true
      );
    } else if (id.includes("second")) {
      let newlineCount = false;
      element.forEach((item) => {
        if (item.type === "output") {
          const normalizedOutput = normalizeOutputReference({
            name: item.name,
            origId: item.origId,
            outputList: currentOutputList.value,
            preferOrigId: preferOrigIdOutputReferences,
          });
          const arr = normalizedOutput.name.split("/#");
          const stepIndex =
            typeof normalizedOutput.index === "number"
              ? normalizedOutput.index
              : -1;
          addOutput(
            {
              name: normalizedOutput.name,
              path: arr.length >= 2 ? `/#${arr[1]}` : "",
              function: item.function,
              stepIndex,
              stepNumber: normalizedOutput.stepNumber,
              origId: normalizedOutput.origId ?? item.origId,
            },
            true,
            false
          );
        } else if (item.type === "input") {
          if (item.name === "\n") {
            newlineCount = true;
            addBrElement();
          } else {
            addText(item, computedId.value);
          }
        } else if (item.type === "user-defined-variable") {
          const arr = item.name.split("/#");
          const name = arr.length >= 2 ? `/#${arr[1]}` : "";
          addUserVariable(
            {
              name,
              path: name,
            },
            true,
            false
          );
        } else if (item.type === "system-variable") {
          const systemVariables = {
            name: item.name,
            tooltip: props.systemVariables[item.name] || "",
          };
          addSystemVariable(systemVariables, false);
        } else {
          const matchedExpression = props.expressions.find(
            (expression) => expression.name === item.name
          );
          const tooltip = matchedExpression?.description;
          const params = { ...item, tooltip };
          addFunction(params, true);
        }
      });
      if (newlineCount) {
        addBrElement();
      }
    }
  } catch (e) {
    console.log(e);
  }
}

function addText(item, divId) {
  const text = document.createTextNode(item.name);
  document.getElementById(divId).appendChild(text);
}

function addUserVariableInput(flag) {
  if (flag === "before") {
    udvChangeMapBefore.value.push({ itemKey: "", itemValue: "" });
  } else if (flag === "after") {
    udvChangeMapAfter.value.push({ itemKey: "", itemValue: "" });
  }
}
function removeUserDefinedVariable(index, flag) {
  if (flag === "before") {
    udvChangeMapBefore.value.splice(index, 1);
  } else if (flag === "after") {
    udvChangeMapAfter.value.splice(index, 1);
  }
}
function getInputLengthToCaretPosition(index) {
  let length = 0;
  const inputElement = document.getElementById(computedId.value);
  if (!inputElement) {
    return 0;
  }
  inputElement.childNodes.forEach((node: any, idx) => {
    if (node.nodeType === Node.TEXT_NODE && idx < index) {
      length += node.data.length;
    } else if (node.nodeType === Node.ELEMENT_NODE && idx < index) {
      length += node.innerText.length;
    }
  });
  return length;
}
const storedRange = ref<Range | null>(null);

function onBlur(e: FocusEvent) {
  storedRange.value = saveCaretPosition(e.target as Node);
}

function addItemToInput(span: HTMLSpanElement, first, isFirstInput) {
  ensureCaretRestored(computedId.value, storedRange.value);
  const zeroWidthSpace = document.createTextNode("\u200B");
  const container = document.getElementById(computedId.value);
  const current: any = getNextSibling(true);
  const nextNode = getNextSibling();
  if (
    current &&
    current.item.nodeType === Node.TEXT_NODE &&
    current.item.data.length > 1 &&
    !first
  ) {
    const [firstText, second] = split(
      current.item.data,
      getCaretPosition(document.getElementById(computedId.value)) -
        getInputLengthToCaretPosition(current.index)
    );
    const firstElem = current.item;
    firstElem.data = firstText;
    document
      .getElementById(computedId.value)
      .replaceChild(firstElem, current.item);
    if (nextNode.item) {
      document
        .getElementById(computedId.value)
        .insertBefore(span, nextNode.item);
    } else {
      document.getElementById(computedId.value).appendChild(span);
    }

    if (nextNode.item) {
      document
        .getElementById(computedId.value)
        .insertBefore(document.createTextNode(second), nextNode.item);
    } else {
      document
        .getElementById(computedId.value)
        .appendChild(document.createTextNode(second));
    }
  } else {
    addToDocument(
      span,
      zeroWidthSpace,
      nextNode ? nextNode.item : undefined,
      first
    );
  }
  let trailingNode: Text;
  if (span.nextSibling && span.nextSibling.nodeType === Node.TEXT_NODE) {
    trailingNode = span.nextSibling as Text;
    if (
      trailingNode.textContent === "" ||
      trailingNode.textContent === "\u200B"
    ) {
      trailingNode.textContent = "\u200B";
      (trailingNode as any).dataset = { caretAnchor: "true" };
    }
  } else {
    trailingNode = document.createTextNode("\u200B");
    (trailingNode as any).dataset = { caretAnchor: "true" };
    container.insertBefore(trailingNode, span.nextSibling);
  }
  const flag = determineFlagCondition();
  organizeNodes(isFirstInput, flag);
  setCaretPosition(span, computedId.value);
}
function determineFlagCondition() {
  if (focusId.value.includes("after")) {
    return "after";
  }
  return "before";
}
function organizeNodes(isFirst, flag) {
  try {
    document
      .getElementById(computedId.value)
      .childNodes.forEach((child, index) => {
        const nextChild = document
          .getElementById(computedId.value)
          .childNodes.item(index + 1);
        if (nextChild) {
          if (
            nextChild.nodeType === child.nodeType &&
            child.nodeType !== Node.TEXT_NODE
          ) {
            const zeroWidthSpace = document.createTextNode("\u200B");
            document
              .getElementById(computedId.value)
              .insertBefore(zeroWidthSpace, nextChild);
          } else if (
            child?.previousSibling?.nodeType === Node.TEXT_NODE &&
            nextChild.nodeType === child.nodeType &&
            child.nodeType === Node.TEXT_NODE
          ) {
            if (
              nextChild.textContent === "\u200B" ||
              child.textContent === "\u200B"
            ) {
              document
                .getElementById(computedId.value)
                .removeChild(
                  child.textContent !== "\u200B" ? nextChild : child
                );
            } else {
              child.textContent += nextChild.textContent;
              child.textContent = child.textContent.replace("\u200B", "");
              document.getElementById(computedId.value).removeChild(nextChild);
            }
          }
        }
      });
  } catch (e) {
    console.log(e, "organize");
  }
  convertToInputString(isFirst, flag);
}
function preventLetters(event) {
  const forbiddenChars = /[a-zA-Z0-9öÖçÇşŞıİğĞüÜ0 ]/;
  if (
    forbiddenChars.test(event.key) &&
    !["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(event.key)
  ) {
    event.preventDefault();
  }
}
function onKeyDown(event) {
  const div = document.getElementById(computedId.value);
  if (event.key === "Enter") {
    if (div.childNodes.length === 0) {
      addBrElement();
    } else if (div.childNodes.length === 1) {
      const node = div.childNodes[0];
      const isBr =
        node.nodeType === Node.ELEMENT_NODE &&
        node?.tagName?.toLowerCase() === "br";
      if (!isBr) {
        addBrElement();
      }
    }
    event.preventDefault();
    insertNewLine(div);
  } else if (event.key === "Backspace") {
    if (
      div.childNodes.length === 1 &&
      div.childNodes[0] instanceof HTMLBRElement
    ) {
      div.removeChild(div.childNodes[0]);
    }
    if (handleBackspaceZWSP(div, computedId.value)) {
      event.preventDefault();
    }
  }
}

function addBrElement() {
  const br = document.createElement("br");
  document.getElementById(computedId.value).appendChild(br);
}

function insertNewLine(div) {
  const br = document.createElement("br");
  const selection = window.getSelection();
  const range = selection.getRangeAt(0);
  range.deleteContents();
  range.insertNode(br);
  range.setStartAfter(div.childNodes[div.childNodes.length - 1]);
  range.collapse(true);
  selection.removeAllRanges();
  selection.addRange(range);
}

function convertToInputString(isFirst, flag) {
  try {
    const inputArray = [];
    document
      .getElementById(computedId.value)
      .childNodes.forEach((child: any) => {
        if (child instanceof HTMLBRElement) {
          inputArray.push({
            name: Array(1).fill("\n").join(""),
            type: "input",
            function: "",
          });
        } else if (child.nodeType === Node.ELEMENT_NODE) {
          inputArray.push({
            name: child.getAttribute("name"),
            origId: child.getAttribute("origId"),
            type: child.getAttribute("type"),
            function: child.getAttribute("function"),
          });
        } else if (
          child.nodeType === Node.TEXT_NODE &&
          child.textContent !== "" &&
          child.textContent !== "\u200B"
        ) {
          inputArray.push({
            name: child.textContent.replaceAll("\u200B", ""),
            type: "input",
          });
        }
      });
    if (
      inputArray.length > 0 &&
      inputArray[inputArray.length - 1]?.name === "\n"
    ) {
      inputArray.pop();
    }
    const targetMap =
      flag === "before" ? udvChangeMapBefore.value : udvChangeMapAfter.value;
    if (isFirst) {
      inputArray.forEach((element) => {
        targetMap[focusInputId.value].itemKey = element.name;
      });
    } else if (inputArray.length === 0) {
      targetMap[focusInputId.value].itemValue = "";
    } else {
      targetMap[focusInputId.value].itemValue = inputArray;
    }
    if (!isFirst) {
      const evt = new Event("change", {
        bubbles: true,
        cancelable: false,
      });
      document
        .getElementById(`${focusId.value}-input-${props.idSuffix}`)
        .dispatchEvent(evt);
    }
  } catch (e) {
    console.log(e, "string");
  }
}
function addToDocument(span, zero, next, first) {
  if (next && !first) {
    document.getElementById(computedId.value).insertBefore(span, next);
    document.getElementById(computedId.value).insertBefore(zero, span);
  } else {
    document.getElementById(computedId.value).appendChild(span);
    document.getElementById(computedId.value).appendChild(zero);
  }
}

function getNextSibling(current?) {
  const elem = document.getElementById(computedId.value);
  const position = getCaretPosition(elem);
  let length = 0;
  let set = false;
  let childIndex = -1;
  elem.childNodes.forEach((child: any, index) => {
    if (child.nodeType === Node.TEXT_NODE) {
      length += child.data.length;
    } else if (child.nodeType === Node.ELEMENT_NODE) {
      length += child.innerText.length;
    }
    if (position <= length && !set && position !== 0) {
      childIndex = index;
      set = true;
    } else if (position === 0) {
      childIndex = -2;
      set = true;
    }
  });
  if (childIndex > -1) {
    return current
      ? {
          item: elem.childNodes.item(childIndex),
          index: childIndex,
        }
      : {
          item: elem.childNodes.item(childIndex + 1),
          index: childIndex + 1,
        };
  }
  if (childIndex === -2) {
    return {
      item: elem.childNodes.item(0),
      index: 0,
    };
  }
  return null;
}
function convertMapToBody(map) {
  const body = {};
  if (selectedBodyMap.value.size !== 0) {
    map.forEach((value, key) => {
      const arr = [];
      value.values.forEach((val) => {
        let object = {};
        object = {
          name: val.name,
          description: val.description,
          bodyRequestType: val.bodyRequestType,
          actionDefinitions: convertToDefinitions(val.data),
          dataType: value.dataType,
          children: !isEmpty(val.children)
            ? convertMapToBody(val.children)
            : undefined,
        };
        arr.push(object);
      });
      body[key] = arr;
    });
    return body;
  }
  return undefined;
}

const areActionsAvailable = computed(
  () => selectedConnection.value && actions.value && actions.value.length > 0
);

watch(selectedAction, (newValue, oldValue) => {
  if (newValue && oldValue) {
    if (newValue.actionSpec?.name !== oldValue.actionSpec?.name) {
      isActionChanged.value = true;
    }
  }
  drawerState.value.clear();
  configurationSchemas.value = newValue
    ? newValue.configurationSchemas
    : undefined;
  schema.value = newValue ? newValue.schema : undefined;

  checkName(oldValue, newValue);
  const savedActionName = props.step.actions
    ? Object.keys(props.step.actions)[0]
    : null;
  const savedActionMatches =
    savedActionName && savedActionName === newValue?.actionSpec?.name;

  // Re-read the step whenever the selection lands on the saved action, not only the first time:
  // switching away clears the form by design (OT-4556), so coming back has to restore what the
  // step still holds or the user's saved values are gone until they reload the page. Gated on the
  // action having actually changed, so a re-fetch of the same action - a revision change, a cache
  // miss - keeps the edits in progress instead of reverting them to what was saved.
  const actionChangedIdentity =
    oldValue?.actionSpec?.name !== newValue?.actionSpec?.name;

  if (savedActionMatches && actionChangedIdentity) {
    const actionsObj = props.step.actions;
    const actionName = Object.keys(actionsObj)[0];
    formData.value = actionsObj[actionName]?.actionDefinitions ?? {};
    const bodyData = actionsObj[actionName]?.bodyActions ?? {};

    if (!isEmpty(bodyData) && newValue?.requestBodies) {
      selectedBodyMap.value = convertToBodyMap(
        bodyData,
        newValue.requestBodies
      );
    }

    formData.value = convertObject(formData.value);
    // JsonForms seeds its own state from `data` on creation and does not re-read it, so restoring
    // formData is not enough on its own: without a new key the expression renderers keep the state
    // they were built with when the form was cleared, and fields like Set Content stay blank while
    // plain inputs appear to update. The else branch below bumps this for the same reason.
    actionChanged.value++;
  } else {
    const prevData = formData.value || {};
    const mergedData = {};

    const shouldPreserve =
      oldValue &&
      newValue &&
      oldValue.actionSpec?.name === newValue.actionSpec?.name;

    if (shouldPreserve && schema.value && schema.value.properties) {
      Object.keys(schema.value.properties).forEach((key) => {
        if (prevData[key] !== undefined) {
          mergedData[key] = prevData[key];
        }
      });
    }
    formData.value = mergedData;

    const prevBodyMap = new Map(selectedBodyMap.value);
    const newBodyMap = new Map<string, any>();
    if (shouldPreserve && selectedAction.value?.requestBodies) {
      selectedAction.value.requestBodies.forEach((body: any) => {
        if (prevBodyMap.has(body.name)) {
          newBodyMap.set(body.name, prevBodyMap.get(body.name));
        }
      });
    }
    selectedBodyMap.value = newBodyMap;
    actionChanged.value++;
  }
  previousStepData.value = stepData.value;
  emitStepData();
});

function checkName(oldAction, newAction) {
  if (
    oldAction &&
    newAction &&
    stepName.value === oldAction.actionSpec.description
  ) {
    stepName.value = newAction.actionSpec.description;
  } else if (
    oldAction &&
    !newAction &&
    stepName.value === oldAction.actionSpec.description
  ) {
    stepName.value = "";
  } else if (stepName.value === "" && newAction) {
    stepName.value = newAction.actionSpec.description;
  }
}

function convertToBodyMap(data, bodies) {
  const newMap = new Map();
  Object.entries(data).forEach(([key, value]: any[]) => {
    const index = bodies.findIndex((o: any) => o.name === key);
    const body = bodies[index];
    const objArr = [];
    value.forEach((val) => {
      objArr.push({
        name: body.name,
        path: body.path,
        description: body.description,
        bodyRequestType: body.bodyRequestType,
        schema: cloneDeep(body.schema),
        childrenBodies: body.children,
        children: !isEmpty(val.children)
          ? convertToBodyMap(val.children, body.children)
          : {},
        dataType: body.dataType,
        data: convertObject(val.actionDefinitions),
      });
    });
    newMap.set(key, {
      dataType: body.dataType,
      values: objArr,
    });
  });
  return newMap;
}

function convertObject(data) {
  const object = {};
  Object.entries(data).forEach(([key, value]: any[]) => {
    object[key] = value.value;
  });
  return object;
}
const connectorIsSwagger = ref(false);
let isActionSet = false;
const skipRevisionFetch = ref(false);

/**
 * Monotonic request counters. Every async action load captures the current value and applies its
 * result only if it is still current, so a slow response from a previous connector, connection,
 * revision or action name can never land on top of a newer one. The action name alone cannot tell
 * those apart, because the same name exists across revisions and across connections of the same
 * dynamic connector.
 */
let actionListRequest = 0;
let actionDetailRequest = 0;

function startActionListRequest() {
  actionListRequest += 1;
  // A new list belongs to a different connector, connection or revision, so any detail still in
  // flight is for the previous one.
  actionDetailRequest += 1;
  return actionListRequest;
}

function startActionDetailRequest() {
  actionDetailRequest += 1;
  return actionDetailRequest;
}

/**
 * The selected action cannot be loaded — from an empty response or a rejected request. Drops the
 * selection so no form is rendered for it; the step's saved data is left untouched.
 */
function clearUnavailableAction() {
  selectedActionName.value = undefined;
  showAlert(TYPE.ERROR, t("Common.ConnectorError"));
}

/** CONSUMER-only for a flow's first step, as the old client-side filter did — now server-side. */
function actionTypeFilterForStep() {
  return props.stepIdx === 0 && !props.isStepInRouter ? "CONSUMER" : undefined;
}

/** Stage 1. Names and labels only — enough to render the dropdown, nothing more. */
/**
 * A dynamic-spec connector stores its action list per connection rather than per connector
 * revision, so it has to be fetched by connection id. Returns undefined for every other connector.
 */
function dynamicConnectionId(connection: any): string | undefined {
  return isDynamicConnector(connection?.connector) ? connection?.id : undefined;
}

async function loadActionList(
  connectorSpecId: string,
  revision?: string,
  connectionId?: string
) {
  if (connectionId) {
    // Dynamic-spec connectors keep the single-document endpoint: their spec UI lives in
    // DynamicSpec, which the two-stage endpoints do not read. The whole list arrives here, so
    // stage 2 resolves the definition locally (see loadActionDefinition).
    const full = actionTypeFilterForStep()
      ? await getConsumerActions(connectorSpecId, revision, connectionId)
      : await getAllActions(connectorSpecId, revision, connectionId);
    return full ? full.map((action) => markRaw(action)) : undefined;
  }
  const summaries = await getActionSummaries(
    connectorSpecId,
    revision,
    actionTypeFilterForStep()
  );
  return summaries ? summaries.map((summary) => markRaw(summary)) : undefined;
}

/** Stage 2 source: the per-action endpoint normally, the already-loaded list when dynamic. */
async function loadActionDefinition(
  connectorSpecId: string,
  actionName: string
) {
  if (dynamicConnectionId(selectedConnection.value)) {
    return actions.value?.find(
      (action) => action?.actionSpec?.name === actionName
    );
  }
  return getActionDetail(connectorSpecId, selectedRevision.value, actionName);
}

/**
 * Stage 2. Assigns `selectedActionDetail` exactly once on success so watch(selectedAction) sees a
 * direct old->new transition. A stale response — the user moved on while it was in flight — is
 * dropped rather than overwriting the newer selection.
 */
async function loadActionDetail(connectorSpecId: string, actionName: string) {
  if (!actionName) {
    return;
  }
  const request = startActionDetailRequest();
  actionDetailLoading.value = true;
  try {
    const detail = await loadActionDefinition(connectorSpecId, actionName);
    if (
      request !== actionDetailRequest ||
      selectedActionName.value !== actionName
    ) {
      return;
    }
    if (detail) {
      selectedActionDetail.value = markRaw(detail);
    } else {
      // Gone from this revision, or the request failed.
      clearUnavailableAction();
    }
  } catch (e) {
    // A rejected request leaves the same situation as an empty one: a selected name with no
    // definition behind it. Both take the same path so they cannot diverge.
    if (request === actionDetailRequest) {
      clearUnavailableAction();
    }
  } finally {
    if (request === actionDetailRequest) {
      actionDetailLoading.value = false;
    }
  }
}

/** Restores a saved step's action by name, or clears the selection when it is no longer offered. */
function selectSavedActionName(list: any[]) {
  const actionName = Object.keys(props.step.actions)[0];
  // Names are unique within a connector revision, and a step only ever persists the name — there
  // is no id to match on.
  const found = list.some((action) => action?.actionSpec?.name === actionName);
  selectedActionName.value = found ? actionName : undefined;
}

watch(
  () => selectedConnection.value,
  (newValue, oldValue) => {
    if (newValue) {
      const { connectorSpecId } = newValue?.connector ?? {};
      if (oldValue?.connector?.connectorSpecId !== connectorSpecId) {
        skipRevisionFetch.value = true;
      }
    }
  },
  { deep: true, immediate: true }
);

watch(
  () => selectedConnection.value,
  async (newSelectedConnection, oldSelectedConnection) => {
    previousStepData.value = props.step;
    drawerState.value.clear();
    await nextTick();
    if (newSelectedConnection) {
      actionLoading.value = true;
      await fetchRevisions();

      let listRequest = actionListRequest;
      try {
        const { connectorSpecId } = newSelectedConnection.connector;
        const connectionId = dynamicConnectionId(newSelectedConnection);
        // A dynamic-spec connector keeps its actions per connection, so two connections sharing a
        // connectorSpecId have different lists — the spec id alone cannot decide whether to reload.
        const listIsStale =
          oldSelectedConnection?.connector?.connectorSpecId !==
            connectorSpecId ||
          (!!connectionId &&
            oldSelectedConnection?.id !== newSelectedConnection.id);
        if (listIsStale) {
          listRequest = startActionListRequest();
          // Left undefined on failure: the template's connector-error warning keys off that, and
          // an empty array would silently look like "this connector has no actions".
          const list = await loadActionList(
            connectorSpecId,
            selectedRevision.value,
            connectionId
          );
          if (listRequest !== actionListRequest) {
            return;
          }
          actions.value = list;
          connectorIsSwagger.value =
            newSelectedConnection.connector.camelComponentName === "swagger";
          if (props.step.actions && !isActionSet && actions.value?.length) {
            selectSavedActionName(actions.value);
            isActionSet = true;
          } else {
            selectedActionName.value = undefined;
            selectedActionDetail.value = undefined;
            selectedBodyMap.value.clear();
            actionChanged.value++;
          }
          if (selectedActionName.value) {
            await loadActionDetail(connectorSpecId, selectedActionName.value);
          }
        }
        emitStepData();
      } catch (e) {
        // A failed list load must not leave the previous connector's actions on screen.
        if (listRequest === actionListRequest) {
          actions.value = undefined;
          selectedActionName.value = undefined;
          selectedActionDetail.value = undefined;
        }
      }
      if (listRequest === actionListRequest) {
        actionLoading.value = false;
      }
    }
  }
);

watch(
  () => selectedRevision.value,
  async (newRevision, oldRevision) => {
    if (skipRevisionFetch.value === true) {
      skipRevisionFetch.value = false;
      return;
    }
    if (
      newRevision === null ||
      newRevision === undefined ||
      newRevision === "" ||
      oldRevision === null ||
      oldRevision === undefined ||
      oldRevision === ""
    ) {
      return;
    }

    const oldActionName = selectedActionName.value;
    if (selectedConnection.value && newRevision !== oldRevision) {
      actionLoading.value = true;
      const listRequest = startActionListRequest();
      try {
        const { connectorSpecId } = selectedConnection.value.connector;
        const list = await loadActionList(
          connectorSpecId,
          newRevision,
          dynamicConnectionId(selectedConnection.value)
        );
        if (listRequest !== actionListRequest) {
          return;
        }
        actions.value = list;
        connectorIsSwagger.value =
          selectedConnection.value.connector.camelComponentName === "swagger";
        const stillOffered =
          oldActionName &&
          actions.value?.some((a) => a?.actionSpec?.name === oldActionName);
        selectedActionName.value = stillOffered ? oldActionName : undefined;
        if (stillOffered) {
          // The name is unchanged, so the name watcher will not fire — but the definition belongs
          // to the previous revision and has to be re-fetched explicitly.
          await loadActionDetail(connectorSpecId, oldActionName);
        } else {
          selectedActionDetail.value = undefined;
        }

        isActionSet = true;
        emitStepData();
      } catch (e) {
        if (listRequest === actionListRequest) {
          actions.value = undefined;
          selectedActionName.value = undefined;
          selectedActionDetail.value = undefined;
        }
      }
      if (listRequest === actionListRequest) {
        actionLoading.value = false;
      }
    }
  }
);

watch(
  () => selectedConnectionId.value,
  (newValue, oldValue) => {
    if (newValue && oldValue) {
      const oldConnectorSpecId = shownConnections.value.find(
        (connection) => connection.id === oldValue
      )?.connector?.connectorSpecId;

      const newConnectorSpecId = shownConnections.value.find(
        (connection) => connection.id === newValue
      )?.connector?.connectorSpecId;

      if (oldConnectorSpecId !== newConnectorSpecId) {
        translations.value = [];
        contentPath.value = "";
      }
      emitStepData();
    }
  }
);

watch(
  () => selectedActionName.value,
  async (newValue, oldValue) => {
    if (newValue && newValue !== oldValue) {
      // Fetch before clearing anything, so watch(selectedAction) still sees the old definition as
      // its previous value and can decide what to preserve.
      if (selectedConnection.value) {
        await loadActionDetail(
          selectedConnection.value.connector.connectorSpecId,
          newValue
        );
      }
      if (oldValue) {
        translations.value = [];
        contentPath.value = "";
        emitStepData();
      }
    }
  }
);
function refreshStep() {
  savedActionDiscarded.value = true;
  translations.value = [];
  selectedConnectionId.value = undefined;
  actions.value = [];
  actionQuery.value = "";
  selectedActionName.value = undefined;
  selectedActionDetail.value = undefined;
  actionDetailLoading.value = false;
  formData.value = {};
  selectedBodyMap.value.clear();
  udvChangeMapAfter.value = [];
  udvChangeMapBefore.value = [];
  emitStepData();
}

function showOutput() {
  if (flowId.value) {
    simulateDialogVisible.value = true;
    selectedBuffer.value = lastLogForStep.value || outputMap.get(flowId) || [];
  }
}

function onTabClick(tab) {
  expressionDrawer(false);
  if (tab?.props?.name === "udv") {
    userDefinedVariablesDialog();
  }
  if (tab?.props?.name === "step") {
    userDefVarDialog.value = false;
    outputDataList.value = defaultOutput.value;
  }
  isKeySelected.value = false;
  isValueSelected.value = false;
  clearActiveFunctionInjectionTarget(editStepUdvInjectionTarget);

  jsonVisible.value = false;
  emit("change-function-visible", false);

  drawerState.value.clear();
}
function closeTranslationDialog() {
  translationDialog.value = false;
}

function saveTranslation(data) {
  const obj = {};
  obj[data.type] = data.name;
  translations.value.push(obj);
  emitStepData();
}

function removeFunction(index) {
  translations.value.splice(index, 1);
  emitStepData();
}

function closeSimulateDialog() {
  simulateDialogVisible.value = false;
}

// Bubble up to EditVueFlow.vue, which owns the WizardDrawer instance.
function handleAnalyzeWithWizard(activityIdToAnalyze: string) {
  simulateDialogVisible.value = false;
  emit("analyze-with-wizard", activityIdToAnalyze);
}

function closeOutputDataDialog() {
  dialogVisible.value = false;
}

function closeDataMapperDialog() {
  dataMapperDialogState.value = false;
}

function addMapToStep(map) {
  if (map.size > 0) {
    resultList = [];
    map.forEach((val, key) => {
      resultList.push(`${key}=>${val.value}`);
    });
    dataMappingObject.value.dataMapping = resultList;
    dataMappingObject.value.targetStepId = nextStepData.value.targetStepId;
    dataMappingObject.value.targetConnectorSpecId =
      nextStepData.value.targetConnectorSpecId;
    dataMappingObject.value.srcConnectorSpecId =
      selectedConnection.value.connector.connectorSpecId;
    dataMapperDialogState.value = false;
    emitStepData();
  } else {
    dataMapperDialogState.value = false;
    dataMappingObject.value = {
      dataMapping: undefined,
      targetStepId: undefined,
      srcConnectorSpecId: undefined,
      targetConnectorSpecId: undefined,
    };
    emitStepData();
  }
}

watch(
  () => props.outputList,
  () => {
    if (props?.step?.availableOutput) {
      defaultOutput.value = props.outputList.filter((item: any) =>
        props?.step?.availableOutput.some((subItem) => {
          const subUnique = String(subItem?.uniqueId);
          const itemUnique = String(item?.uniqueId);
          return (
            itemUnique === subUnique || itemUnique.startsWith(`${subUnique}-`)
          );
        })
      );
      alternativeOutput.value = [...defaultOutput.value];
      const currentStepOutput = props.outputList.find(
        (item: any) => item.id === props.step.id
      );
      if (
        currentStepOutput &&
        !alternativeOutput.value.some((item) => item.id === props.step.id)
      ) {
        alternativeOutput.value.push(currentStepOutput);
      }
      outputDataList.value = defaultOutput.value;
    }
    if (props.step?.output) {
      let convertedOutput;
      try {
        convertedOutput = JSON.stringify(JSON.parse(props.step?.output));
        outputData.value = convertedOutput;
      } catch (e) {
        outputData.value = JSON.stringify({
          output: { "invalid output": "invalid output" },
        });
        console.log("invalid json");
      }
    }
  },
  { deep: true, immediate: true }
);

watch(
  () => outputDataList.value,
  () => {
    if (activeTab.value === "udv" && focusId.value.includes("after")) {
      const [baseId] = focusId.value.split(`-${focusInputId.value}`);
      nextTick(() => setFocusInput(focusInputId.value, baseId));
    }
  }
);
watch(
  () => props.metaoutputList,
  () => {
    if (props?.step?.availableMetaoutput) {
      metaoutputDataList.value = props.metaoutputList.filter((item: any) =>
        props?.step?.availableMetaoutput.some((subItem) => {
          const subUnique = String(subItem?.uniqueId);
          const itemUnique = String(item?.uniqueId);
          return (
            itemUnique === subUnique || itemUnique.startsWith(`${subUnique}-`)
          );
        })
      );
    }
    if (props.step?.metaoutput) {
      let convertedMetaOutput;
      try {
        convertedMetaOutput = JSON.stringify(
          JSON.parse(props.step?.metaoutput)
        );
        metaoutputData.value = convertedMetaOutput;
      } catch (e) {
        metaoutputData.value = JSON.stringify({
          output: { "invalid output": "invalid output" },
        });
        console.log("invalid json");
      }
    }
  },
  { deep: true, immediate: true }
);

function openOutputDialog() {
  dialogVisible.value = true;
}

watch(
  () => simulating.value,
  () => {
    emit("updateSimulate", simulating.value);
  }
);
const stepChanges = ref(false);

watch(
  () => stepName.value,
  () => {
    previousStepData.value = stepData.value;
    // emit("change", stepData.value);
  }
);
watch(
  () => continueOnFail.value,
  () => {
    previousStepData.value = stepData.value;
  }
);
onBeforeMount(async () => {
  // Must stay ahead of the first await: onMounted paints these rows into their contenteditable
  // divs by walking udvChangeMapBefore/After, and an await here lets the component mount before
  // the rows exist, so onMounted walks an empty list and the Custom Field Mapping tab renders
  // blank even though the step's data is present.
  if (props.step.udvChangeMapBefore) {
    const entries = Object.entries(props.step.udvChangeMapBefore);
    entries.forEach(([key, value]) => {
      const obj = {
        itemKey: isUdvValueOnlyKey(key) ? "" : key,
        itemValue: value,
        valueOnlyKey: isUdvValueOnlyKey(key) ? key : undefined,
      };
      udvChangeMapBefore.value.push(obj);
    });
  }
  if (props.step.udvChangeMapAfter) {
    const entries = Object.entries(props.step.udvChangeMapAfter);
    entries.forEach(([key, value]) => {
      const obj = {
        itemKey: isUdvValueOnlyKey(key) ? "" : key,
        itemValue: value,
        valueOnlyKey: isUdvValueOnlyKey(key) ? key : undefined,
      };
      udvChangeMapAfter.value.push(obj);
    });
  }
  // Resolved before selectedConnectionId is set below, so the first action load already renders
  // the right window. Both lookups are memoized per page load, so re-creating this component on
  // every step click costs no extra requests.
  [actionPageSize.value, actionGroupingThresholds.value] = await Promise.all([
    getActionDropdownRenderLimit(),
    getActionGroupingThresholds(),
  ]);
  resetActionWindow();
  if (props.step.actions) {
    const keys = Object.keys(props.step.actions);
    const [key] = keys;
    // New or partially configured steps can have no saved action/definitions.
    // An absent custom body must not abort name and connection initialization.
    const customRequestBodyDefinition =
      props.step.actions[key]?.actionDefinitions?.[CUSTOM_REQUEST_BODY_KEY];
    if (customRequestBodyDefinition?.value) {
      customRequestBodyData.value = {
        [CUSTOM_REQUEST_BODY_KEY]: customRequestBodyDefinition.value,
      };
      validateCustomRequestBody(customRequestBodyDefinition.value);
      if (USE_LEGACY_ADVANCED_EDITOR) {
        const inputBodyJson = JSON.parse(customRequestBodyDefinition.value);
        let inputBodyString = "";
        inputBodyJson.forEach((body) => {
          if (body.type === "user-defined-variable") {
            const [, splittedName] = body.name.split("/userDefinedVariables");
            body.name = `#OT-UDV#${splittedName}#OT-UDV`;
          }
          if (body.type === "system-variable") {
            body.name = `#OT-SYS#/#${body.name}#OT-SYS`;
          }
          if (body.type === "output") {
            body.name = `#OT-OUT#${body.name}#OT-OUT`;
          }
          if (body.type === "function") {
            body.name = `#OT-FNC#/#${body.name}#OT-FNC`;
          }
          inputBodyString += body.name;
        });
        jsonEditorValue.value = JSON.parse(inputBodyString);
      }
    }
  }

  if (props.step.translations) {
    translations.value = JSON.parse(JSON.stringify(props.step.translations));
  }
  if (props.step.dataMapping) {
    if (props.step.dataMapping.dataMapping) {
      dataMappingObject.value.dataMapping = props.step.dataMapping.dataMapping;
      savedMap.value = props.step.dataMapping.dataMapping;
    }
  }
  if (props.step.contentPath) {
    contentPath.value = props.step.contentPath;
  }
  if (props.step.connection) {
    selectedConnectionId.value = props.step.connection.id;
  } else if (props.step.connectorSpecId) {
    // Reload a connection-less step: reselect its synthetic connector entry.
    selectedConnectionId.value = `connector:${props.step.connectorSpecId}`;
  }
  stepChanges.value = props.isStepChanged;
  stepName.value = props.step.name ? props.step.name : "";
  continueOnFail.value = props.step.continueOnFail
    ? props.step.continueOnFail
    : false;
  continueOnFailDisable.value = props.flow.continueOnFailure;
  getBaseUrl().then((resp) => {
    restUrl.value = resp;
  });
});

onUnmounted(() => {
  clearActiveFunctionInjectionTarget(editStepUdvInjectionTarget);
  debouncedEmitChange.flush();
  debouncedValidateCustomRequestBody.cancel();
  if (client?.value) {
    client.value.disconnect();
    client.value = undefined;
  }
  emit("setLoading", false);
  // emit("change", previousStepData.value);
});

function updateBodyMap(data) {
  selectedBodyMap.value = data;
  previousStepData.value = stepData.value;
  debouncedEmitChange();
}

function updateCurrentSavedData() {
  debouncedEmitChange.flush();
  previousStepData.value = stepData.value;
  emitStepData();
}

function resetStepChanges() {
  stepChanges.value = false;
  emit("step-change", false);
}

__expose({
  updateCurrentSavedData,
  resetConnectionAndActionChanges,
  resetStepChanges,
  simulate,
});

function onChangeOverrideObjectList(newList) {
  overrideObjectList.value = newList;
}

async function loadLastLogForStep() {
  if (!props?.flow?.id || !props?.flow?.version) return;

  const logInfo = await getElasticLogs(props.flow.id, props.flow.version);
  if (!logInfo) return;
  const activityLog = await getFlowLogByActivityId(logInfo.id);
  activityId.value = logInfo.id;
  // AI-274: processLog is plain text now; splitByTime already drops empty fragments, so the
  // "StepProcessLog(id=null, log=" wrapper filter that used to sit here is no longer needed.
  lastLogForStep.value = activityLog.flowLogDto.stepLogs
    .map((item) => splitByTime(item.processLog))
    .flat();
  processLogs.value = lastLogForStep.value;
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (
            typeof stepData.value.id === 'string' &&
            !_ctx.step.id.includes('new') &&
            !_ctx.step.id.includes('router')
          )
          ? (_openBlock(), _createBlock(_unref(ElTooltip), {
              key: 0,
              effect: "custom",
              placement: "left",
              content: _unref(t)('Flow.ProcessLogs')
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-link nav-link-func-header step-toolbar-button",
                  id: "flow-logs",
                  onClick: showOutput,
                  disabled: 
              (!selectedBuffer.value ||
                selectedBuffer.value?.length === 0 ||
                simulateDialogVisible.value) &&
              !lastLogForStep.value
            
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: "align-justify" })
                ], 8, _hoisted_4)
              ]),
              _: 1
            }, 8, ["content"]))
          : _createCommentVNode("", true),
        (stepData.value.output)
          ? (_openBlock(), _createBlock(_unref(ElTooltip), {
              key: 1,
              effect: "custom",
              placement: "left",
              content: _unref(t)('Flow.OutputData')
            }, {
              default: _withCtx(() => [
                (stepData.value.output)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-link nav-link-func-header step-toolbar-button",
                      id: "flow-output",
                      onClick: openOutputDialog,
                      disabled: disableOutputButton()
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "database" })
                    ], 8, _hoisted_5))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["content"]))
          : _createCommentVNode("", true),
        (nextOutputData.value)
          ? (_openBlock(), _createBlock(_unref(ElTooltip), {
              key: 2,
              effect: "custom",
              placement: "left",
              content: _unref(t)('Flow.DataMapper')
            }, {
              default: _withCtx(() => [
                (nextOutputData.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-link nav-link-func-header step-toolbar-button",
                      id: "flow-mapper",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (dataMapperDialogState.value = true)),
                      disabled: disableOutputButton()
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "exchange-alt" })
                    ], 8, _hoisted_6))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["content"]))
          : _createCommentVNode("", true),
        (selectedConnectionId.value && activeTab.value !== 'udv')
          ? (_openBlock(), _createBlock(_unref(ElTooltip), {
              key: 3,
              effect: "custom",
              placement: "left",
              content: _unref(t)('Flow.StepFunctions')
            }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-link nav-link-func-header step-toolbar-button",
                  id: "flow-translation",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (translationDialog.value = !translationDialog.value), ["stop"]))
                }, _hoisted_8)
              ]),
              _: 1
            }, 8, ["content"]))
          : _createCommentVNode("", true),
        (selectedConnectionId.value)
          ? (_openBlock(), _createBlock(_unref(ElTooltip), {
              key: 4,
              effect: "custom",
              placement: "left",
              content: _unref(t)('Flow.ClearStep')
            }, {
              default: _withCtx(() => [
                (selectedConnectionId.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-link nav-link-func-header step-toolbar-button",
                      id: "flow-clean",
                      onClick: refreshStep
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "trash" })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["content"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: "card-header header-label d-flex flex-row align-items-center justify-content-between",
          style: {"position":"relative"},
          onClick: closeTranslationDialog
        }, [
          _createVNode(_unref(ElTabs), {
            modelValue: activeTab.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeTab).value = $event)),
            class: "step-tabs",
            onTabClick: onTabClick,
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElTabPane), {
                id: `step-details-${props.idSuffix}`,
                label: _unref(t)('Common.StepDetails'),
                name: "step"
              }, null, 8, ["id", "label"]),
              _createVNode(_unref(ElTabPane), {
                id: `user-defined-variables-${props.idSuffix}`,
                label: _unref(t)('Common.CustomFieldMapping'),
                name: "udv"
              }, null, 8, ["id", "label"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-link",
            id: "flow-close-step",
            style: {"position":"absolute","right":"10px","top":"8px"},
            onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('closeDrawer')))
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "times" })
          ])
        ]),
        (activeTab.value === 'step' && !userDefVarDialog.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "card-body p-0 font-size-14 step-drawer-body",
              onClick: closeTranslationDialog,
              id: 'json-form-component' + _ctx.stepIdx
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_unref(ElScrollbar), { class: "step-details-scrollbar" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      (!actions.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "info-circle",
                              color: "red"
                            }),
                            _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(t)("Common.ConnectorError")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Name")), 1),
                        _createVNode(_unref(ElInput), {
                          onInput: onStepNameInput,
                          modelValue: stepName.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((stepName).value = $event)),
                          id: "flow-step-name",
                          size: "small",
                          placeholder: "Step Name..."
                        }, null, 8, ["modelValue"])
                      ]),
                      (isNameNearLimit.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)("Common.CharacterLimitWarning", { limit: charLimit.value })), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (selectedAction.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            (continueOnFailDisable.value)
                              ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                                  key: 0,
                                  effect: "custom",
                                  placement: "bottom",
                                  content: _unref(t)('Flow.FlowContinueOnFailLabel')
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ElSwitch), {
                                      disabled: continueOnFailDisable.value,
                                      modelValue: continueOnFail.value,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((continueOnFail).value = $event)),
                                      label: _unref(t)('Flow.StepContinueOnFail'),
                                      size: "large",
                                      "active-color": "#5022a6",
                                      class: "element-switch-oneteg align-items-center",
                                      width: 48
                                    }, null, 8, ["disabled", "modelValue", "label"]),
                                    _createVNode(_unref(ElCheckbox), {
                                      disabled: continueOnFailDisable.value,
                                      modelValue: continueOnFail.value,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((continueOnFail).value = $event)),
                                      label: _unref(t)('Flow.StepContinueOnFail'),
                                      size: "large"
                                    }, null, 8, ["disabled", "modelValue", "label"])
                                  ]),
                                  _: 1
                                }, 8, ["content"]))
                              : (_openBlock(), _createBlock(_unref(ElSwitch), {
                                  key: 1,
                                  disabled: continueOnFailDisable.value,
                                  modelValue: continueOnFail.value,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((continueOnFail).value = $event)),
                                  label: _unref(t)('Flow.StepContinueOnFail'),
                                  size: "large",
                                  "active-color": "#5022a6",
                                  class: "element-switch-oneteg align-items-center",
                                  width: 48
                                }, null, 8, ["disabled", "modelValue", "label"])),
                            _createElementVNode("span", {
                              class: _normalizeClass(
                      continueOnFailDisable.value ? 'text-color-gray' : 'color-black'
                    )
                            }, _toDisplayString(_unref(t)("Flow.StepContinueOnFail")), 3)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("strong", null, [
                          _createTextVNode(_toDisplayString(_unref(t)("Common.Connection")), 1),
                          _hoisted_20
                        ]),
                        _createVNode(_unref(ElSelect), {
                          modelValue: selectedConnectionId.value,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selectedConnectionId).value = $event)),
                          onChange: onStepChange,
                          filterable: "",
                          size: "large",
                          disabled: openPopUp.value,
                          id: "flow-connection-select",
                          placeholder: "Select a connection"
                        }, {
                          prefix: _withCtx(() => [
                            _createElementVNode("span", _hoisted_21, [
                              (selectedConnectionId.value)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    class: "logo-30",
                                    src: `${_unref(ASSETS_BASE_URL)}/${
                            selectedConnection.value?.connector?.connectorSpecId
                          }${_unref(getResolution)(false)}.png`,
                                    alt: "logo",
                                    style: {"margin-right":"8px"}
                                  }, null, 8, _hoisted_22))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedConnections.value, (group) => {
                              return (_openBlock(), _createBlock(_unref(ElOptionGroup), {
                                key: group.label,
                                label: _unref(t)(group.label)
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.options
                          .filter(
                            (conn) =>
                              conn.active || conn.id === selectedConnectionId.value
                          )
                          .sort((a, b) => a.name.localeCompare(b.name)), (connection) => {
                                    return (_openBlock(), _createBlock(_unref(ElOption), {
                                      id: connection.connector.connectorSpecId,
                                      label: connection.name,
                                      value: connection.id,
                                      key: connection.name,
                                      disabled: !connection.active,
                                      style: _normalizeStyle({ maxWidth: dropdownSize.value, height: 'auto' })
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", {
                                          style: {"float":"left"},
                                          class: _normalizeClass({
                            'inactive-option':
                              !connection.active &&
                              connection.id === selectedConnectionId.value,
                          })
                                        }, [
                                          _createElementVNode("img", {
                                            class: "logo",
                                            src: `${_unref(ASSETS_BASE_URL)}/${
                              connection.connector.connectorSpecId
                            }${_unref(getResolution)(false)}.png`,
                                            alt: "logo"
                                          }, null, 8, _hoisted_23),
                                          _createTextVNode(" " + _toDisplayString(connection.name), 1)
                                        ], 2)
                                      ]),
                                      _: 2
                                    }, 1032, ["id", "label", "value", "disabled", "style"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      (
                    selectedConnectionId.value &&
                    !(revisions.value.length === 1 && revisions.value[0] === 0)
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.ConnectorRevision")), 1),
                            _createVNode(_unref(ElSelect), {
                              modelValue: selectedRevision.value,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((selectedRevision).value = $event)),
                              onChange: onStepChange,
                              disabled: !selectedConnectionId.value || !revisions.value.length,
                              filterable: "",
                              size: "small",
                              placeholder: "Select a revision"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(revisions.value, (revision) => {
                                  return (_openBlock(), _createBlock(_unref(ElOption), {
                                    key: revision,
                                    label: revision,
                                    value: revision,
                                    style: _normalizeStyle({ maxWidth: dropdownSize.value, height: 'auto' })
                                  }, null, 8, ["label", "value", "style"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled"])
                          ]))
                        : _createCommentVNode("", true),
                      (isWebhook())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createVNode(_unref(ElTooltip), {
                              effect: "custom",
                              content: webhookUrl.value,
                              placement: "bottom"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("label", null, _toDisplayString(webhookUrl.value.slice(0, 47)) + "...", 1)
                              ]),
                              _: 1
                            }, 8, ["content"]),
                            _createVNode(_unref(ElButton), {
                              class: "btn-oneTeg",
                              onClick: copyUrlToClipboard,
                              id: "flow-url-copy",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, { icon: "clone" })
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (selectedConnection.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("strong", null, [
                                _createTextVNode(_toDisplayString(_unref(t)("Common.Action")), 1),
                                _hoisted_28
                              ]),
                              (actionGroupingViable.value)
                                ? (_openBlock(), _createBlock(_unref(ElCheckbox), {
                                    key: 0,
                                    id: "flow-action-group-toggle",
                                    modelValue: groupSelectorEnabled.value,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((groupSelectorEnabled).value = $event)),
                                    label: _unref(t)('Flow.UseGroupSelector'),
                                    disabled: openPopUp.value,
                                    size: "small",
                                    onChange: persistGroupSelectorPreference
                                  }, null, 8, ["modelValue", "label", "disabled"]))
                                : _createCommentVNode("", true)
                            ]),
                            (showActionGroupSelector.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  _createElementVNode("strong", null, _toDisplayString(_unref(t)("Flow.ActionGroup")), 1),
                                  _createVNode(_unref(ElSelect), {
                                    id: "flow-action-group-select",
                                    modelValue: selectedActionGroup.value,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((selectedActionGroup).value = $event)),
                                    disabled: !areActionsAvailable.value || openPopUp.value,
                                    filterable: "",
                                    size: "small",
                                    onChange: onActionGroupChange
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(ElOption), {
                                        label: _unref(t)('Flow.AllActionGroups'),
                                        value: ALL_ACTION_GROUPS,
                                        style: _normalizeStyle({ maxWidth: dropdownSize.value, height: 'auto' })
                                      }, null, 8, ["label", "style"]),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actionGroupSummaries.value, (group) => {
                                        return (_openBlock(), _createBlock(_unref(ElOption), {
                                          key: group.value,
                                          label: `${group.label} (${group.count})`,
                                          value: group.value,
                                          style: _normalizeStyle({ maxWidth: dropdownSize.value, height: 'auto' })
                                        }, null, 8, ["label", "value", "style"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "disabled"])
                                ]))
                              : _createCommentVNode("", true),
                            (actionLoading.value || actionDetailLoading.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                  _createElementVNode("img", {
                                    src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
                                    alt: "Loading...",
                                    class: "loader-logo-25"
                                  }, null, 8, _hoisted_31)
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(_unref(ElSelect), {
                              disabled: !areActionsAvailable.value || openPopUp.value,
                              loading: actionLoading.value || actionDetailLoading.value,
                              id: "flow-action-select",
                              filterable: "",
                              "filter-method": onActionFilter,
                              onVisibleChange: onActionDropdownVisibleChange,
                              size: "small",
                              onChange: onStepChange,
                              placeholder: 
                      actions.value?.length === 0
                        ? 'No action available for this step'
                        : 'Select an action'
                    ,
                              modelValue: selectedActionName.value,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((selectedActionName).value = $event))
                            }, {
                              default: _withCtx(() => [
                                (actionGroups.value)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(actionGroups.value, (group, groupIx) => {
                                      return (_openBlock(), _createBlock(_unref(ElOptionGroup), {
                                        key: `${group.key ?? 'ungrouped'}-${groupIx}`,
                                        label: group.label
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                                            return (_openBlock(), _createBlock(ActionOption, {
                                              key: item.action.actionSpec.name,
                                              "action-spec": item.action.actionSpec,
                                              "dropdown-size": dropdownSize.value,
                                              grouped: ""
                                            }, null, 8, ["action-spec", "dropdown-size"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["label"]))
                                    }), 128))
                                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(filteredActions.value, (item) => {
                                      return (_openBlock(), _createBlock(ActionOption, {
                                        key: item.action.actionSpec.name,
                                        "action-spec": item.action.actionSpec,
                                        "dropdown-size": dropdownSize.value,
                                        grouped: _unref(actionRowsDropTag)
                                      }, null, 8, ["action-spec", "dropdown-size", "grouped"]))
                                    }), 128)),
                                (hasMoreActions.value)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 2,
                                      ref_key: "actionSentinelRef",
                                      ref: actionSentinelRef,
                                      class: "action-load-more-sentinel"
                                    }, null, 512))
                                  : _createCommentVNode("", true),
                                (showActionCountHint.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(hasMoreActions.value
                          ? _unref(t)("Flow.ActionListTruncated", {
                              shown: filteredActions.value.length,
                              total: orderedActions.value.length,
                            })
                          : _unref(t)("Flow.ActionListComplete", {
                              total: orderedActions.value.length,
                            })), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["disabled", "loading", "placeholder", "modelValue"]),
                            _withDirectives(_createElementVNode("div", _hoisted_33, [
                              _createElementVNode("strong", null, _toDisplayString(_unref(t)("Flow.ActionSettings")), 1),
                              _createElementVNode("div", _hoisted_34, [
                                (schema.value)
                                  ? (_openBlock(), _createBlock(_unref(JsonForms), {
                                      key: actionChanged.value,
                                      data: formData.value,
                                      onHandleClickEvent: handleClickEvent,
                                      onExpressionDrawer: expressionDrawer,
                                      renderers: _unref(renderers),
                                      schema: renameTooltipFieldsInSchema(schema.value),
                                      ajv: _unref(ajv),
                                      stepIdx: _ctx.stepIdx,
                                      outputList: outputDataList.value,
                                      userDefinedVariables: _ctx.userDefinedVariables,
                                      "system-variables": _ctx.systemVariables,
                                      expressions: _ctx.expressions,
                                      metaoutputList: metaoutputDataList.value,
                                      onUpdatePopUpOpen: _cache[13] || (_cache[13] = ($event: any) => (popUpOpened($event))),
                                      onChange: onFormChange,
                                      onInput: onStepChange
                                    }, null, 8, ["data", "renderers", "schema", "ajv", "stepIdx", "outputList", "userDefinedVariables", "system-variables", "expressions", "metaoutputList"]))
                                  : _createCommentVNode("", true)
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(configurationSchemas.value, (item) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "dynamic-categories",
                                  key: item.categoryDescription
                                }, [
                                  _createElementVNode("strong", null, [
                                    _createTextVNode(_toDisplayString(item.categoryDescription), 1),
                                    _hoisted_35
                                  ]),
                                  (schema.value)
                                    ? (_openBlock(), _createBlock(_unref(JsonForms), {
                                        key: actionChanged.value,
                                        data: formData.value,
                                        renderers: _unref(renderers),
                                        onHandleClickEvent: handleClickEvent,
                                        onExpressionDrawer: expressionDrawer,
                                        schema: renameTooltipFieldsInSchema(item),
                                        ajv: _unref(ajv),
                                        stepIdx: _ctx.stepIdx,
                                        outputList: outputDataList.value,
                                        userDefinedVariables: _ctx.userDefinedVariables,
                                        "system-variables": _ctx.systemVariables,
                                        expressions: _ctx.expressions,
                                        metaoutputList: metaoutputDataList.value,
                                        onUpdatePopUpOpen: _cache[14] || (_cache[14] = ($event: any) => (popUpOpened($event))),
                                        onChange: onFormChange,
                                        onInput: onStepChange
                                      }, null, 8, ["data", "renderers", "schema", "ajv", "stepIdx", "outputList", "userDefinedVariables", "system-variables", "expressions", "metaoutputList"]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128)),
                              (isRequestBody.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: actionChanged.value,
                                    class: "margin-top-10 margin-bottom-10"
                                  }, [
                                    _createVNode(_unref(RequestBodyView), {
                                      requestBodies: selectedAction.value.requestBodies,
                                      "step-idx": _ctx.stepIdx,
                                      "output-list": outputDataList.value,
                                      "user-defined-variables": _ctx.userDefinedVariables,
                                      "system-variables": _ctx.systemVariables,
                                      expressions: _ctx.expressions,
                                      "existing-data": selectedBodyMap.value,
                                      "child-count": 0,
                                      metaoutput: metaoutputDataList.value,
                                      "connector-is-swagger": connectorIsSwagger.value,
                                      "connector-spec-id": 
                          selectedConnection.value?.connector?.connectorSpecId
                        ,
                                      "transformed-input": props.step?.transformedInput,
                                      "transformed-output": props.step?.transformedOutput,
                                      "transformed-prompt": props.step?.transformedPrompt,
                                      "is-step-changed": stepChanges.value,
                                      "is-simulating": simulating.value,
                                      "simulation-data-refresh-key": 
                          props.simulationDataRefreshKey
                        ,
                                      onSimulateForSpec: _cache[15] || (_cache[15] = 
                          (payload) => emit('simulate-for-spec', payload)
                        ),
                                      onSaveAfterSpec: _cache[16] || (_cache[16] = 
                          (payload) => emit('save-after-spec', payload)
                        ),
                                      onUpdateData: updateBodyMap,
                                      onHandleClickEvent: handleClickEvent,
                                      onExpressionDrawer: expressionDrawer,
                                      objectInjectionModalVisibleKey: modalVisibleKey.value,
                                      onChangeObjectInjectionModalVisibleKey: _cache[17] || (_cache[17] = ($event: any) => (
                          modalVisibleKey.value = $event
                        )),
                                      "override-object-list": overrideObjectList.value,
                                      onChangeOverrideObjectList: 
                          onChangeOverrideObjectList
                        ,
                                      onOnInputChange: onStepChange,
                                      onUpdateShowCustomRequestBody: 
                          toggleShowCustomRequestBody
                        
                                    }, null, 8, ["requestBodies", "step-idx", "output-list", "user-defined-variables", "system-variables", "expressions", "existing-data", "metaoutput", "connector-is-swagger", "connector-spec-id", "transformed-input", "transformed-output", "transformed-prompt", "is-step-changed", "is-simulating", "simulation-data-refresh-key", "objectInjectionModalVisibleKey", "override-object-list", "onChangeOverrideObjectList", "onUpdateShowCustomRequestBody"]),
                                    _withDirectives(_createElementVNode("div", _hoisted_36, [
                                      USE_LEGACY_ADVANCED_EDITOR
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                            _createElementVNode("strong", null, _toDisplayString(_unref(t)("Flow.CustomRequestBody")), 1),
                                            _createVNode(_unref(JsonEditorVue), {
                                              id: "json-editor",
                                              modelValue: jsonEditorValue.value,
                                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((jsonEditorValue).value = $event)),
                                              mode: 'tree',
                                              navigationBar: false,
                                              style: {"height":"350px"},
                                              onInput: onJsonEditorChange,
                                              onSelect: onSelect,
                                              onRenderValue: onRenderValue,
                                              onRenderMenu: 
                              (items) => items.splice(3, items.length)
                            
                                            }, null, 8, ["modelValue", "onRenderMenu"])
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                            _createVNode(_unref(JsonForms), {
                                              data: customRequestBodyData.value,
                                              renderers: _unref(renderers),
                                              schema: customRequestBodySchema,
                                              ajv: _unref(ajv),
                                              stepIdx: _ctx.stepIdx,
                                              outputList: outputDataList.value,
                                              userDefinedVariables: _ctx.userDefinedVariables,
                                              "system-variables": _ctx.systemVariables,
                                              expressions: _ctx.expressions,
                                              metaoutputList: metaoutputDataList.value,
                                              onHandleClickEvent: handleClickEvent,
                                              onExpressionDrawer: expressionDrawer,
                                              onChange: onCustomRequestBodyChange
                                            }, null, 8, ["data", "renderers", "ajv", "stepIdx", "outputList", "userDefinedVariables", "system-variables", "expressions", "metaoutputList"]),
                                            (customRequestBodyInvalid.value)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(_unref(t)("Flow.CustomRequestBodyInvalidJson")), 1))
                                              : _createCommentVNode("", true)
                                          ]))
                                    ], 512), [
                                      [_vShow, showCustomRequestBody.value]
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 512), [
                              [_vShow, !_unref(isEmpty)(schema.value?.properties) || isRequestBody.value]
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                (contentPath.value || translations.value.length !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      (contentPath.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _createElementVNode("strong", null, _toDisplayString(_unref(t)("Flow.ContextPath")) + ": ", 1),
                            _createVNode(_unref(ElTag), {
                              size: "small",
                              type: "info",
                              style: {"margin":"5px"},
                              closable: "",
                              onClose: clearContentPath
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(contentPath.value.replaceAll("/#", "/").replaceAll("@#", "/")), 1)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _withDirectives(_createElementVNode("div", _hoisted_42, [
                        _createElementVNode("strong", null, _toDisplayString(_unref(t)("Flow.StepFunctions")), 1),
                        _createElementVNode("div", _hoisted_43, [
                          _createVNode(_unref(ElScrollbar), { "max-height": '10vh' }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(translations.value, (value, index) => {
                                return (_openBlock(), _createBlock(_unref(ElTag), {
                                  style: {"margin":"5px"},
                                  key: `${
                        value.expressionType ||
                        value.translationType ||
                        value.translationOperationType
                      }-${index}`,
                                  class: _normalizeClass({
                        'exp-step-function-tag': !!value.expressionType,
                        'opr-step-function-tag':
                          !!value.translationOperationType,
                        'translation-step-function-tag':
                          !!value.translationType,
                      }),
                                  size: "mini",
                                  effect: "dark",
                                  closable: "",
                                  onClose: ($event: any) => (removeFunction(index))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(value.expressionType ||
                        value.translationType ||
                        value.translationOperationType), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["class", "onClose"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ])
                      ], 512), [
                        [_vShow, translations.value.length !== 0]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 8, _hoisted_10))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_unref(ElScrollbar), {
          "max-height": isKeySelected.value ? '68vh' : '80vh'
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", {
              class: "card-body p-0 font-size-14",
              onClick: userDefinedVariablesDialog,
              id: 'json-form-component' + _ctx.stepIdx
            }, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", {
                  class: "p-8-16",
                  id: `definitions-` + _ctx.idSuffix
                }, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.BeforeExecution")), 1),
                    _createElementVNode("div", _hoisted_48, [
                      _createVNode(_unref(ElButton), {
                        class: "no-border btn-oneTeg2",
                        size: "mini",
                        type: "primary",
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (addUserVariableInput('before')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "plus" })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  (udvChangeMapBefore.value.length > 0)
                    ? (_openBlock(), _createBlock(_unref(ElDivider), {
                        key: 0,
                        style: {"margin":"10px 0"}
                      }))
                    : _createCommentVNode("", true),
                  (udvChangeMapBefore.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        _createElementVNode("span", _hoisted_50, _toDisplayString(_unref(t)("Common.Variable")), 1),
                        _createElementVNode("span", _hoisted_51, _toDisplayString(_unref(t)("Common.Value")), 1),
                        _hoisted_52
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(udvChangeMapBefore.value, (udv, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: udv,
                      class: "d-flex align-items-start justify-content-center gap-2 full-width"
                    }, [
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", {
                          class: "input-div",
                          onMouseenter: ($event: any) => (hoveredField.value = `first-definition-${index}`),
                          onMouseleave: _cache[22] || (_cache[22] = ($event: any) => (hoveredField.value = ''))
                        }, [
                          _createElementVNode("input", {
                            value: udv.itemKey,
                            style: {"display":"none"},
                            id: 'first-definition-' + index + '-input-' + _ctx.idSuffix,
                            "data-id": 
                          'first-definition-' + index + '-data-' + _ctx.idSuffix
                        ,
                            class: "input form-control"
                          }, null, 8, _hoisted_55),
                          (hoveredField.value === `first-definition-${index}`)
                            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                key: 0,
                                icon: 
                          recentlyCopied.value ===
                          `first-definition-${index}-div-${_ctx.idSuffix}`
                            ? 'check'
                            : 'copy'
                        ,
                                class: "copy-icon",
                                onClick: ($event: any) => (
                          copyDefinitionContent(index, 'first-definition')
                        )
                              }, null, 8, ["icon", "onClick"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            id: 'first-definition-' + index + '-div-' + _ctx.idSuffix,
                            contenteditable: "true",
                            class: "form-control root-div",
                            onBlur: onBlur,
                            onContextmenu: _cache[20] || (_cache[20] = _withModifiers(() => {}, ["prevent"])),
                            onInput: ($event: any) => (onUdvKeyChange(index, 'before', $event)),
                            onChange: onStepChange,
                            onKeyup: _cache[21] || (_cache[21] = ($event: any) => (organizeNodes(true, 'before'))),
                            onClick: ($event: any) => (setFocusInput(index, 'first-definition')),
                            onKeydown: preventLetters,
                            spellcheck: "false"
                          }, null, 40, _hoisted_56),
                          _hoisted_57
                        ], 40, _hoisted_54)
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", {
                          class: "input-div",
                          onMouseenter: ($event: any) => (hoveredField.value = `second-definition-${index}`),
                          onMouseleave: _cache[24] || (_cache[24] = ($event: any) => (hoveredField.value = ''))
                        }, [
                          _createElementVNode("input", {
                            value: udv.itemValue,
                            style: {"display":"none"},
                            id: 
                          'second-definition-' + index + '-input-' + _ctx.idSuffix
                        ,
                            "data-id": 
                          'second-definition-' + index + '-input-' + _ctx.idSuffix
                        ,
                            class: "input form-control"
                          }, null, 8, _hoisted_60),
                          (hoveredField.value === `second-definition-${index}`)
                            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                key: 0,
                                icon: 
                          recentlyCopied.value ===
                          `second-definition-${index}-div-${_ctx.idSuffix}`
                            ? 'check'
                            : 'copy'
                        ,
                                class: "copy-icon",
                                onClick: ($event: any) => (
                          copyDefinitionContent(index, 'second-definition')
                        )
                              }, null, 8, ["icon", "onClick"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            id: 'second-definition-' + index + '-div-' + _ctx.idSuffix,
                            contenteditable: "true",
                            class: "form-control root-div",
                            onBlur: onBlur,
                            onKeyup: _cache[23] || (_cache[23] = ($event: any) => (organizeNodes(false, 'before'))),
                            onClick: ($event: any) => (setFocusInput(index, 'second-definition')),
                            onInput: onStepChange,
                            onPasteCapture: _withModifiers(pasteEvent, ["prevent"]),
                            onKeydown: onKeyDown,
                            style: {"white-space":"pre-wrap","display":"inline-block","overflow":"visible"},
                            spellcheck: "false"
                          }, null, 40, _hoisted_61),
                          _hoisted_62
                        ], 40, _hoisted_59)
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("button", {
                          class: "btn btn-link icon-btn udv-action-btn",
                          type: "button",
                          onClick: ($event: any) => (removeUserDefinedVariable(index, 'before'))
                        }, [
                          _createVNode(_component_font_awesome_icon, { icon: "trash" })
                        ], 8, _hoisted_64)
                      ])
                    ]))
                  }), 128))
                ], 8, _hoisted_46)
              ])
            ], 8, _hoisted_44), [
              [_vShow, userDefVarDialog.value]
            ]),
            _withDirectives(_createVNode(_unref(ElDivider), { style: {"margin":"15px 0","width":"96%","margin-left":"auto","margin-right":"auto"} }, null, 512), [
              [_vShow, userDefVarDialog.value]
            ]),
            _withDirectives(_createElementVNode("div", {
              class: "card-body p-0 font-size-14",
              onClick: userDefinedVariablesDialog,
              id: 'json-form-component' + _ctx.stepIdx
            }, [
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", {
                  class: "p-8-16",
                  id: `definitions-` + _ctx.idSuffix
                }, [
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.AfterExecution")), 1),
                    _createElementVNode("div", _hoisted_69, [
                      _createVNode(_unref(ElButton), {
                        class: "no-border btn-oneTeg2",
                        size: "mini",
                        type: "primary",
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (addUserVariableInput('after')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "plus" })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  (udvChangeMapAfter.value.length > 0)
                    ? (_openBlock(), _createBlock(_unref(ElDivider), {
                        key: 0,
                        style: {"margin":"10px 0"}
                      }))
                    : _createCommentVNode("", true),
                  (udvChangeMapAfter.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                        _createElementVNode("span", _hoisted_71, _toDisplayString(_unref(t)("Common.Variable")), 1),
                        _createElementVNode("span", _hoisted_72, _toDisplayString(_unref(t)("Common.Value")), 1),
                        _hoisted_73
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(udvChangeMapAfter.value, (udv, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: udv,
                      class: "d-flex align-items-start justify-content-center gap-2 full-width"
                    }, [
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("div", {
                          class: "input-div",
                          onMouseenter: ($event: any) => (
                        hoveredField.value = `first-after-definition-${index}`
                      ),
                          onMouseleave: _cache[28] || (_cache[28] = ($event: any) => (hoveredField.value = ''))
                        }, [
                          _createElementVNode("input", {
                            value: udv.itemKey,
                            style: {"display":"none"},
                            id: 
                          'first-after-definition-' +
                          index +
                          '-input-' +
                          _ctx.idSuffix
                        ,
                            "data-id": 
                          'first-after-definition-' +
                          index +
                          '-input-' +
                          _ctx.idSuffix
                        ,
                            class: "input form-control"
                          }, null, 8, _hoisted_76),
                          (
                          hoveredField.value === `first-after-definition-${index}`
                        )
                            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                key: 0,
                                icon: 
                          recentlyCopied.value ===
                          `first-after-definition-${index}-div-${_ctx.idSuffix}`
                            ? 'check'
                            : 'copy'
                        ,
                                class: "copy-icon",
                                onClick: ($event: any) => (
                          copyDefinitionContent(index, 'first-after-definition')
                        )
                              }, null, 8, ["icon", "onClick"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            id: 
                          'first-after-definition-' + index + '-div-' + _ctx.idSuffix
                        ,
                            contenteditable: "true",
                            class: "form-control root-div",
                            onContextmenu: _cache[26] || (_cache[26] = _withModifiers(() => {}, ["prevent"])),
                            onInput: ($event: any) => (onUdvKeyChange(index, 'after', $event)),
                            onChange: onStepChange,
                            onBlur: onBlur,
                            onKeyup: _cache[27] || (_cache[27] = ($event: any) => (organizeNodes(true, 'after'))),
                            onClick: ($event: any) => (setFocusInput(index, 'first-after-definition')),
                            onKeydown: preventLetters,
                            spellcheck: "false"
                          }, null, 40, _hoisted_77),
                          _hoisted_78
                        ], 40, _hoisted_75)
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("div", {
                          class: "input-div",
                          onMouseenter: ($event: any) => (
                        hoveredField.value = `second-after-definition-${index}`
                      ),
                          onMouseleave: _cache[30] || (_cache[30] = ($event: any) => (hoveredField.value = ''))
                        }, [
                          _createElementVNode("input", {
                            value: udv.itemValue,
                            style: {"display":"none"},
                            id: 
                          'second-after-definition-' +
                          index +
                          '-input-' +
                          _ctx.idSuffix
                        ,
                            "data-id": 
                          'second-after-definition-' +
                          index +
                          '-input-' +
                          _ctx.idSuffix
                        ,
                            class: "input form-control"
                          }, null, 8, _hoisted_81),
                          (
                          hoveredField.value === `second-after-definition-${index}`
                        )
                            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                key: 0,
                                icon: 
                          recentlyCopied.value ===
                          `second-after-definition-${index}-div-${_ctx.idSuffix}`
                            ? 'check'
                            : 'copy'
                        ,
                                class: "copy-icon",
                                onClick: ($event: any) => (
                          copyDefinitionContent(
                            index,
                            'second-after-definition'
                          )
                        )
                              }, null, 8, ["icon", "onClick"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            id: 
                          'second-after-definition-' +
                          index +
                          '-div-' +
                          _ctx.idSuffix
                        ,
                            contenteditable: "true",
                            class: "form-control root-div",
                            onBlur: onBlur,
                            onKeyup: _cache[29] || (_cache[29] = ($event: any) => (organizeNodes(false, 'after'))),
                            onClick: ($event: any) => (setFocusInput(index, 'second-after-definition')),
                            onInput: onStepChange,
                            onPasteCapture: _withModifiers(pasteEvent, ["prevent"]),
                            onKeydown: onKeyDown,
                            style: {"white-space":"pre-wrap","display":"inline-block","overflow":"visible"},
                            spellcheck: "false"
                          }, null, 40, _hoisted_82),
                          _hoisted_83
                        ], 40, _hoisted_80)
                      ]),
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("button", {
                          class: "btn btn-link icon-btn udv-action-btn",
                          type: "button",
                          onClick: ($event: any) => (removeUserDefinedVariable(index, 'after'))
                        }, [
                          _createVNode(_component_font_awesome_icon, { icon: "trash" })
                        ], 8, _hoisted_85)
                      ])
                    ]))
                  }), 128))
                ], 8, _hoisted_67)
              ])
            ], 8, _hoisted_65), [
              [_vShow, userDefVarDialog.value]
            ])
          ]),
          _: 1
        }, 8, ["max-height"]), [
          [_vShow, activeTab.value === 'udv']
        ])
      ])
    ]),
    _createVNode(_unref(DataMapperDialog), {
      dialog: dataMapperDialogState.value,
      index: _ctx.stepIdx + 1,
      outputData: outputData.value,
      onClose: closeDataMapperDialog,
      onSave: _cache[31] || (_cache[31] = ($event: any) => (addMapToStep($event))),
      savedMap: savedMap.value,
      moved: true,
      nextStepOutputData: nextOutputData.value
    }, null, 8, ["dialog", "index", "outputData", "savedMap", "nextStepOutputData"]),
    (_openBlock(), _createBlock(_Teleport, { to: "#open-output-popup-dialog" }, [
      (dialogVisible.value)
        ? (_openBlock(), _createBlock(_unref(OutputDataDialog), {
            key: 0,
            dialog: dialogVisible.value,
            outputData: outputData.value,
            onSetPath: _cache[32] || (_cache[32] = ($event: any) => (setContentPath($event))),
            onClose: closeOutputDataDialog,
            path: contentPath.value,
            title: `${_unref(getStepDisplayNumber)(
          _ctx.step.ix,
          _ctx.step.stepNumber
        )}. Step's Output Data`,
            index: _ctx.step.ix + 1
          }, null, 8, ["dialog", "outputData", "path", "title", "index"]))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#proceed-step-popup-dialog" }, [
      (simulateDialogVisible.value)
        ? (_openBlock(), _createBlock(_unref(SimulateDialog), {
            key: 0,
            dialog: simulateDialogVisible.value,
            selectedBuffer: selectedBuffer.value,
            moved: false,
            stoppable: true,
            "activity-id": activityId.value,
            "wizard-enabled": _ctx.wizardEnabled,
            onClose: closeSimulateDialog,
            onDownloadLogsAsText: _cache[33] || (_cache[33] = ($event: any) => (downloadLogsAsText(_ctx.flow))),
            onAnalyzeWithWizard: handleAnalyzeWithWizard
          }, null, 8, ["dialog", "selectedBuffer", "activity-id", "wizard-enabled"]))
        : _createCommentVNode("", true)
    ])),
    USE_LEGACY_ADVANCED_EDITOR
      ? (_openBlock(), _createBlock(_unref(FunctionSelector), {
          key: 0,
          visible: jsonVisible.value,
          mode: "input",
          "id-prefix": 'json-visible-' + _ctx.idSuffix,
          "user-defined-variables": _ctx.userDefinedVariables,
          onAddUserVariable: addUserVariableToJsonEditor,
          "show-other-inputs": true,
          showMeta: true,
          "system-variables": _ctx.systemVariables,
          expressions: _ctx.expressions,
          "output-list": outputDataList.value,
          "metaoutput-list": metaoutputDataList.value,
          onAddOutput: addOutputToJsonEditor,
          onAddFunction: addFunctionToJsonEditor,
          onAddSystemVariable: addSystemVariableToJsonEditor
        }, null, 8, ["visible", "id-prefix", "user-defined-variables", "system-variables", "expressions", "output-list", "metaoutput-list"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(FunctionSelector), {
      visible: translationDialog.value,
      "metaoutput-list": metaoutputDataList.value,
      mode: "function",
      onAddFunction: saveTranslation,
      showMeta: true,
      "show-other-inputs": true,
      "system-variables": _ctx.systemVariables
    }, null, 8, ["visible", "metaoutput-list", "system-variables"]),
    _createVNode(_unref(FunctionSelector), {
      visible: isKeySelected.value,
      mode: "input",
      "user-defined-variables": _ctx.userDefinedVariables,
      "system-variables": _ctx.systemVariables,
      expressions: _ctx.expressions,
      "metaoutput-list": metaoutputDataList.value,
      "id-prefix": 'user-defined-variables-' + _ctx.idSuffix,
      onAddUserVariable: _cache[34] || (_cache[34] = (data, first) => addUserVariable(data, first, true)),
      "show-other-inputs": false,
      showMeta: false
    }, null, 8, ["visible", "user-defined-variables", "system-variables", "expressions", "metaoutput-list", "id-prefix"]),
    _createVNode(_unref(FunctionSelector), {
      visible: isValueSelected.value,
      mode: "input",
      "id-prefix": 'user-defined-variables-' + _ctx.idSuffix,
      "user-defined-variables": _ctx.userDefinedVariables,
      onAddUserVariable: _cache[35] || (_cache[35] = (data, first) => addUserVariable(data, first, false)),
      "show-other-inputs": true,
      showMeta: false,
      "system-variables": _ctx.systemVariables,
      expressions: _ctx.expressions,
      "output-list": outputDataList.value,
      "metaoutput-list": metaoutputDataList.value,
      "function-name": _ctx.clickedFunctionName,
      "selected-variables": selectedVariables.value,
      "show-exp-info": showExpInfo.value,
      onAddOutput: addOutput,
      onAddFunction: addFunction,
      onAddSystemVariable: addSystemVariable
    }, null, 8, ["visible", "id-prefix", "user-defined-variables", "system-variables", "expressions", "output-list", "metaoutput-list", "function-name", "selected-variables", "show-exp-info"])
  ]))
}
}

})